import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Container, Divider, List, ListItem, Typography, Tabs, Tab, Slide, Alert, CircularProgress,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Select, MenuItem, IconButton,
  FormControl, InputLabel, Grid, Card,  Dialog, DialogTitle, DialogActions
} from '@mui/material';
import { db } from '../../firebase';
import { collection, query, where, onSnapshot, doc, updateDoc, getDoc, Timestamp, getDocs, addDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import { Chip } from "@mui/material";
import QRCode from "qrcode";
import { deleteDoc } from "firebase/firestore";
import Autocomplete from "@mui/material/Autocomplete";
function TabPanel({ children, value, index, darkMode, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`order-tabpanel-${index}`}
      aria-labelledby={`order-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Slide direction="left" in={value === index} mountOnEnter unmountOnExit>
          <Box sx={{ p: 3, bgcolor: darkMode ? '#3a3a5c' : '#fff' }}>{children}</Box>
        </Slide>
      )}
    </div>
  );
}

const Order = ({ darkMode,  tableId: propTableId, serviceArea: propServiceArea, companyCode: propCompanyCode, unitCode: propUnitCode, userId: propUserId, managerId, 
  isManagerRoute, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location?.state;
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [companyName, setCompanyName] = useState(null);
  const [assignedTableIds, setAssignedTableIds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [itemWiseTax, setItemWiseTax] = useState(1);
  const [serverInput, setServerInput] = useState("");
   const [transactionDetails, setTransactionDetails] = useState(1);
  const itemRefs = useRef({});
  const highlightOrderId = state?.orderId;
  const highlightItemId = state?.itemId; // Refers to itemInstanceId
  const [itemCode, setItemCode] = useState("");
const [itemName, setItemName] = useState("");
const [quantity, setQuantity] = useState(1);
const [inputStep, setInputStep] = useState("code"); 
const [selectOpen, setSelectOpen] = useState(false);
const selectRef = useRef(null);
const [menuItems, setMenuItems] = useState([]);
const [addedItems, setAddedItems] = useState([]);
const [serviceAreasMap, setServiceAreasMap] = useState({});
const itemCodeRef = useRef(null);
const qtyRef = useRef(null);
const [mainTab, setMainTab] = useState(0);
const [orderPreference, setOrderPreference] = useState("");
const [transactionId, setTransactionId] = useState("");
const [showPaid, setShowPaid] = useState(
  sessionStorage.getItem("showPaid") === "true"
);
const [showCancelled, setShowCancelled] = useState(
  sessionStorage.getItem("showCancelled") === "true"
);
const [showDeleted, setShowDeleted] = useState(
  sessionStorage.getItem("showDeleted") === "true"
);
const [paidSuccessOpen, setPaidSuccessOpen] = useState(false);
const [cancelSuccessOpen, setCancelSuccessOpen] = useState(false);
const [deleteSuccessOpen, setDeleteSuccessOpen] = useState(false);
const [showCategorySeparate, setShowCategorySeparate] = useState(null);
const getServerLabel = (option) =>
  option.userId?.includes("#")
    ? option.userId.split("#")[1]
    : option.userId;
 const [guestItems, setGuestItems] = useState({
  0: [] // items for first guest
});
const [guestTabs, setGuestTabs] = useState([
  { id: 1, label: "New Order", orderPreference: "" }
]);
const [profileData, setProfileData] = useState(1);
const [paymentOptions, setPaymentOptions] = useState([]);
const [selectedPayment, setSelectedPayment] = useState("");
const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
const [gstPlansMap, setGstPlansMap] = useState({});
const [billingPreference, setBillingPreference] = useState("1");
const [checkingCustomer, setCheckingCustomer] = useState(false);
const [customerId, setCustomerId] = useState(null);
const [guestCustomers, setGuestCustomers] = useState({});
const [cartTabMap, setCartTabMap] = useState({});
const confirmLockRef = useRef(false);
const paymentLockRef = useRef(false);
const [servers, setServers] = useState([]);
const [selectedServer, setSelectedServer] = useState("");
  const companyCode =
  propCompanyCode ||
  location?.state?.companyCode ||
  new URLSearchParams(location.search).get("code") ||
  sessionStorage.getItem("companyCode") ||
  localStorage.getItem("companyCode") ||
  null;

const userId =
propUserId ||
  location?.state?.userId ||
  sessionStorage.getItem("userId") ||
  localStorage.getItem("userId") ||
  null;

const unitCode =
propUnitCode ||
  location?.state?.unitCode ||
  new URLSearchParams(location.search).get("unit") ||
  sessionStorage.getItem("unitCode") ||
  localStorage.getItem("unitCode") ||
  null;

  const tableId =
  propTableId ||
  location?.state?.tableId ||
  new URLSearchParams(location.search).get("table") ||
  sessionStorage.getItem("tableId") ||
  null;
  
  const selectedServiceArea = 
  propServiceArea ||
  location.state?.serviceArea || 
    sessionStorage.getItem(`selectedServiceArea_${userId}_${unitCode}`) ||
    ''; // fallback

    const [userRole, setUserRole] = useState("");
useEffect(() => {
  const fetchServers = async () => {
    if (!isManagerRoute || !companyCode || !unitCode) return;

    const q = query(
      collection(db, "users"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode),
      where("role", "==", "servers")
    );

    const snapshot = await getDocs(q);

    const serverList = snapshot.docs.map(doc => {
      const data = doc.data();

      return {
        userId: data.userId,
        serviceArea: data.serviceArea || "",
        displayName: data.userId?.split("#")[1] || data.userId
      };
    });

    setServers(serverList);

// Don't auto-select any server
setSelectedServer("");
  };

  fetchServers();
}, [companyCode, unitCode, isManagerRoute]);

const sortedServers = [...servers].sort((a, b) => {
  const getNumber = (userId) => {
    const namePart = userId?.split("#")[1] || "";
    return parseInt(namePart.split("-")[0], 10) || 0;
  };

  return getNumber(a.userId) - getNumber(b.userId);
});

useEffect(() => {
  const fetchBillingPreference = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Billing Process") // EXACT match
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const data = snapshot.docs[0].data();
        setBillingPreference(Number(data.preferenceValue));
        console.log("Billing Preference:", data.preferenceValue);
      }

    } catch (error) {
      console.error("Billing preference error:", error);
    }
  };

  fetchBillingPreference();
}, [companyCode, unitCode]);

useEffect(() => {
  const fetchItemWiseTaxPreference = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Item Wise Tax")
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const prefData = snapshot.docs[0].data();

        setItemWiseTax(Number(prefData.preferenceValue));
      }
    } catch (err) {
      console.error("Failed to fetch item wise tax preference:", err);
    }
  };

  fetchItemWiseTaxPreference();
}, [companyCode, unitCode]);

useEffect(() => {
  const fetchProfileDataPreference = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Profile Data")
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const prefData = snapshot.docs[0].data();

        setProfileData(Number(prefData.preferenceValue));
      }
    } catch (err) {
      console.error("Failed to fetch profile data preference:", err);
    }
  };

  fetchProfileDataPreference();
}, [companyCode, unitCode]);

useEffect(() => {
  const fetchTransactionDetailsPreference = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Transaction Details")
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const prefData = snapshot.docs[0].data();

        setTransactionDetails(Number(prefData.preferenceValue));
      }
    } catch (err) {
      console.error("Failed to fetch transaction details preference:", err);
    }
  };

  fetchTransactionDetailsPreference();
}, [companyCode, unitCode]);

const [categoryPreference, setCategoryPreference] = useState(null);

useEffect(() => {

  const fetchCategoryPreference = async () => {

    if (!companyCode || !unitCode) return;

    try {

      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Category To Be Shown Separate")
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {

        const prefData = snapshot.docs[0].data();

        setShowCategorySeparate(
  prefData.preferenceValue !== null &&
  prefData.preferenceValue !== undefined &&
  prefData.preferenceValue !== ""
    ? Number(prefData.preferenceValue)
    : null
);

        setCategoryPreference(prefData); // IMPORTANT
      }

    } catch (err) {

      console.error(
        "Failed to fetch category preference:",
        err
      );

    }
  };

  fetchCategoryPreference();

}, [companyCode, unitCode]);

const isServerBlocked = billingPreference === 0 && !isManagerRoute;
useEffect(() => {
  const fetchPaymentOptions = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Payment") 
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const data = snapshot.docs[0].data();

        setPaymentOptions(data.preferenceOptions || []);
      }
    } catch (err) {
      console.error("Error fetching payment methods:", err);
    }
  };

  fetchPaymentOptions();
}, [companyCode, unitCode]);

const currentCustomer = guestCustomers[mainTab] || {};

useEffect(() => {
  const phone = currentCustomer?.phone;

  if (!phone || phone.length !== 10) return;

  const fetchCustomer = async () => {
    setCheckingCustomer(true);

    try {
      const q = query(
        collection(db, "customers"),
        where("phoneNumber", "==", phone),
        where("companyCode", "==", companyCode)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        const data = docSnap.data();

        setGuestCustomers(prev => ({
          ...prev,
          [mainTab]: {
            ...prev[mainTab],
            name: data.name,
            customerExists: true,
            customerId: docSnap.id
          }
        }));
      } else {
        setGuestCustomers(prev => ({
          ...prev,
          [mainTab]: {
            ...prev[mainTab],
            name: "",
            customerExists: false,
            customerId: null
          }
        }));
      }
    } catch (err) {
      console.error("Customer fetch error:", err);
    }

    setCheckingCustomer(false);
  };

  const delay = setTimeout(fetchCustomer, 500);
  return () => clearTimeout(delay);

}, [currentCustomer?.phone, companyCode, mainTab]);

const handleSaveCustomer = async () => {
  try {
    const currentCustomer = guestCustomers[mainTab];

    if (!currentCustomer?.phone || !currentCustomer?.name) return;

    const docRef = await addDoc(collection(db, "customers"), {
      phoneNumber: currentCustomer.phone,
      name: currentCustomer.name,
      companyCode,
      createdAt: serverTimestamp()
    });

    await updateDoc(docRef, {
      id: docRef.id
    });

    setGuestCustomers(prev => ({
      ...prev,
      [mainTab]: {
        ...prev[mainTab],
        customerId: docRef.id,
        customerExists: true
      }
    }));

  } catch (err) {
    console.error("Error saving customer:", err);
  }
};

const getCustomerStorageKey = () => {
  return `customer_${companyCode}_${unitCode}_${tableId}_${mainTab}`;
};
useEffect(() => {
  const savedCustomer = sessionStorage.getItem(getCustomerStorageKey());

  if (savedCustomer) {
    const data = JSON.parse(savedCustomer);

    setGuestCustomers(prev => ({
      ...prev,
      [mainTab]: {
        phone: data.phone || "",
        name: data.name || "",
        customerId: data.customerId || null,
        customerExists: !!data.customerId
      }
    }));
  }
}, [companyCode, unitCode, tableId, mainTab]);

useEffect(() => {
  const current = guestCustomers[mainTab];

  if (!current?.phone && !current?.name) return;

  sessionStorage.setItem(
    getCustomerStorageKey(),
    JSON.stringify(current)
  );
}, [guestCustomers, mainTab]);


const handleNewGuest = () => {

  const newIndex = guestTabs.length;

  setGuestTabs(prev => [
    ...prev,
    { id: Date.now(), label: "New Order", orderPreference: "" }
  ]);

  setGuestItems(prev => ({
    ...prev,
    [newIndex]: []
  }));

  setMainTab(newIndex);
};

useEffect(() => {
  if (!companyCode || !unitCode || !selectedServiceArea || !tableId ) return;

  const q = query(
    collection(db, "carts"),
    where("serviceArea", "==", selectedServiceArea),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode),
    where("tableId", "==", tableId),
    where("assignedServerId", "==", userId)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const liveOrders = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    console.log("Live cart orders:", liveOrders);

    setLiveCartOrders(liveOrders);
  });

  return () => unsubscribe();
}, [companyCode, unitCode, selectedServiceArea]);
const [primaryCartId, setPrimaryCartId] = useState(null);
const [liveCartOrders, setLiveCartOrders] = useState([]);
useEffect(() => {
  if (!liveCartOrders.length) return;

  const sortedCarts = [...liveCartOrders].sort(
    (a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0)
  );

  setCartTabMap(prevMap => {
    let updatedMap = { ...prevMap };

    setGuestTabs(prevTabs => {
      let updatedTabs = [...prevTabs];

      sortedCarts.forEach((cart, index) => {

        if (updatedMap[cart.id] !== undefined) return;

        if (index === 0) {
          //  FIRST cartId → MAIN TAB
          updatedMap[cart.id] = 0;
        } else {
          // DIFFERENT cartId → NEW TAB
          const newIndex = updatedTabs.length;

          updatedTabs.push({
            id: Date.now() + newIndex,
            label: "New Order",
            orderPreference: ""
          });

          updatedMap[cart.id] = newIndex;
        }

      });

      return updatedTabs;
    });

    return updatedMap;
  });

}, [liveCartOrders]);

const handleCloseGuest = (index) => {
  if (guestTabs.length === 1) return; // prevent removing last tab

  const updatedTabs = guestTabs.filter((_, i) => i !== index);

  const updatedItems = { ...guestItems };
  delete updatedItems[index];

  setGuestTabs(updatedTabs);
  setGuestItems(updatedItems);

  if (mainTab >= updatedTabs.length) {
    setMainTab(updatedTabs.length - 1);
  }
};
useEffect(() => {
  if (!companyCode || !unitCode || !tableId) return;

  const key = `guestTabs_${companyCode}_${unitCode}_${tableId}`;
  const savedTabs = sessionStorage.getItem(key);

  if (savedTabs) {
    setGuestTabs(JSON.parse(savedTabs));
  }

}, [companyCode, unitCode, tableId]);

useEffect(() => {
  if (!companyCode || !unitCode || !tableId) return;

  const key = `guestTabs_${companyCode}_${unitCode}_${tableId}`;

  sessionStorage.setItem(key, JSON.stringify(guestTabs));

}, [guestTabs, companyCode, unitCode, tableId]);

useEffect(() => {
  itemCodeRef.current?.focus();
}, []);

const [unitName, setUnitName] = useState("N/A");
const [gstin, setGstin] = useState("");
const [city, setcity] = useState("");
useEffect(() => {
  const fetchUnitName = async () => {
    if (!unitCode) return;

    try {
      const unitDoc = await getDoc(doc(db, "units", unitCode));
      if (unitDoc.exists()) {
        //setUnitName(unitDoc.data().unitName || "N/A");
        const data = unitDoc.data();

        setUnitName(data.unitName || "N/A");
        setcity(data.city || "");
        setGstin(data.gstin || ""); 
      } else {
        console.warn("No unit found for code:", unitCode);
      }
    } catch (error) {
      console.error("Error fetching unit:", error);
    }
  };

  fetchUnitName();
}, [unitCode]);
const serverSelectRef = useRef(null);
useEffect(() => {
  const handleKeyDown = (e) => {
    const active = document.activeElement;

    if (
    paidSuccessOpen ||
    paymentDialogOpen
  ) {
    return;
  }

  const isServerSelect =
  serverSelectRef.current?.contains(document.activeElement);

  if (isServerSelect) return;
    if (active?.tagName === "TEXTAREA") return;
    
    // ENTER → Add item
    /*if (e.key === "Enter") {
     if (billingPreference === 0 && !isManagerRoute) return;
      if ((itemCode || itemName) && quantity >= 1 && selectedServiceArea) {
        e.preventDefault();
        e.stopPropagation();

        handleAddItem();
        setShowQtyControls(false);

        setTimeout(() => {
          itemCodeRef.current?.focus();
        }, 50);
      }
      return;
    }*/

      if (e.key === "Enter") {
  if (billingPreference === 0 && !isManagerRoute) return;

  e.preventDefault();

  /*const matches = menuItems.filter(item =>
    item.itemCode?.toLowerCase().startsWith(itemCode.toLowerCase())
  );*/

  const normalizedCode = itemCode.trim().toLowerCase();

// Exact match first
/*const exactMatch = menuItems.find(
  item => item.itemCode?.toLowerCase() === normalizedCode
);*/
const exactMatch = menuItems.find(
  item =>
    item.itemCode
      ?.trim()
      ?.toLowerCase() === normalizedCode
);

// Partial matches
/*const matches = menuItems.filter(
  item => item.itemCode?.toLowerCase().startsWith(normalizedCode)
);*/

const matches = menuItems.filter(
  item =>
    item.itemCode
      ?.trim()
      ?.toLowerCase()
      .startsWith(normalizedCode)
);

if (inputStep === "code") {

  if (exactMatch) {
    setItemCode(exactMatch.itemCode || "");
    //setItemName(exactMatch.name);
    setItemName(exactMatch.itemName || exactMatch.name || "");

    setShowQtyControls(true);
    setInputStep("qty");

    setTimeout(() => qtyRef.current?.focus(), 50);
    return;
  }

  if (matches.length === 1) {
    //setItemCode(matches[0].itemCode);
    //setItemName(matches[0].name);
    setItemCode(matches[0].itemCode || "");
    setItemName(matches[0].itemName || matches[0].name || "");

    setShowQtyControls(true);
    setInputStep("qty");

    setTimeout(() => qtyRef.current?.focus(), 50);
    return;
  }

  if (matches.length > 1) {
    setInputStep("select");
    setSelectOpen(true);
    return;
  }

  if (!exactMatch && matches.length === 0) {
  setInputStep("select");
  setSelectOpen(true);
  return;
}
  return;
}

if (inputStep === "select") {
  setShowQtyControls(true);
  setInputStep("qty");

  setTimeout(() => qtyRef.current?.focus(), 50);
  return;
}

if (inputStep === "qty") {
  handleAddItem();

  setInputStep("code");
  setItemCode("");
  setItemName("");
  setQuantity(1);
setShowQtyControls(false);
  setTimeout(() => itemCodeRef.current?.focus(), 50);
  return;
}

  return;
}

    // If already typing inside Item Code → allow normal typing
    if (active === itemCodeRef.current) return;
  
    // Typing anywhere → go to item code
    /*if (e.key.length === 1 && active?.tagName !== "INPUT")*/
    if (e.key.length === 1 && active?.tagName !== "INPUT") {
      e.preventDefault();
      itemCodeRef.current?.focus();
      setItemCode(prev => prev + e.key);
    }

    // Backspace
    if (e.key === "Backspace" && active?.tagName !== "INPUT") {
      setItemCode(prev => prev.slice(0, -1));
    }
  };

  // capture phase is the important part
  document.addEventListener("keydown", handleKeyDown, true);

  return () => {
    document.removeEventListener("keydown", handleKeyDown, true);
  };
}, [itemCode, itemName, quantity, selectedServiceArea]);
useEffect(() => {
  if (!itemCode.trim()) {
    setShowQtyControls(false);
    setItemName("");
    setQuantity(1);
    setInputStep("code");
  }
}, [itemCode]);

  useEffect(() => {
  const fetchServiceAreaNameAndCategory = async () => {
   if (!companyCode || !unitCode || !selectedServiceArea) return;

    try {
      const docRef = doc(db, "serviceAreas", selectedServiceArea);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setServiceAreasMap(prev => ({
          ...prev,
          [selectedServiceArea]: {
            name: data.serviceAreaName,
            category: data.priceCategory, // ← This is important
          },
        }));
        console.log('Fetched service area info:', data);
      } else {
        console.warn('Service area not found for ID:', selectedServiceArea);
      }
    } catch (err) {
      console.error("Failed to fetch service area:", err);
    }
  };

  fetchServiceAreaNameAndCategory();
}, [companyCode, unitCode,selectedServiceArea]);


  const fetchMenuItems = async () => {
  try {
    const q = query(
      collection(db, "companymenu"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode)
    );

    const snapshot = await getDocs(q);

    const items = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setMenuItems(items);
  } catch (err) {
    console.error("Failed to load menu items", err);
  }
};

useEffect(() => {
  if (!itemCode) {
    setItemName("");
    return;
  }

  const matchedItem = menuItems.find(
    (item) => item.itemCode?.toLowerCase() === itemCode.toLowerCase()
  );

  if (matchedItem) {
    setItemName(matchedItem.name);
  }
}, [itemCode, menuItems]);

const increaseQty = () => {
  setQuantity(prev => prev + 1);
};

const decreaseQty = () => {
  if (quantity > 1) {
    setQuantity(prev => prev - 1);
  }
};

/*useEffect(() => {
  if (!itemCode) {
    setItemName("");
    setShowQtyControls(false);
    return;
  }

  // Get all matching items
  const matchedItems = menuItems.filter(item =>
    item.itemCode?.toLowerCase().startsWith(itemCode.toLowerCase())
  );

  if (matchedItems.length === 1) {
    // Only one item found
    setItemName(matchedItems[0].name);
    setShowQtyControls(true);

    // Move cursor to qty
    setTimeout(() => {
      qtyRef.current?.focus();
      qtyRef.current?.select();
    }, 50);

  } else {
    // Multiple or no matches
    setItemName("");
    setShowQtyControls(false);
  }
}, [itemCode, menuItems]);*/

useEffect(() => {
  if (!itemCode) {
    setItemName("");
    return;
  }

  // only reset name, DO NOT auto assign
  setItemName("");
}, [itemCode]);

  const fetchCompanyName = async () => {
    if (!companyCode) {
      setCompanyName('Unknown Company');
      console.log('Order: No companyCode for fetching company name');
      return;
    }
    try {
      const companyDocRef = doc(db, 'units', unitCode);
      const companyDoc = await getDoc(companyDocRef);
      if (companyDoc.exists()) {
        const companyData = companyDoc.data();
        setCompanyName(companyData.companyName || 'Unknown Company');
        console.log('Order: Company details fetched:', { name: companyData.name, companyCode });
      } else {
        setCompanyName('Unknown Company');
        console.log('Order: No company found for companyCode:', companyCode);
      }
    } catch (err) {
      console.error('Order: Error fetching company details:', err);
      setCompanyName('Unknown Company');
      setError(`Failed to fetch company details: ${err.message}`);
    }
  };

  const fetchAssignedTables = async () => {
    if (!companyCode || !selectedServiceArea || !unitCode) {
      console.warn('Order: Missing parameters for fetching assigned tables', { companyCode, selectedServiceArea, unitCode });
      return [];
    }
    try {
      const tablesQuery = query(
        collection(db, 'tables'),
        where('companyCode', '==', companyCode),
        where('unitCode', '==', unitCode),
        //where('assignedServer', '==', userId)
        where("serviceArea", "==", selectedServiceArea)
      );
      const tablesSnapshot = await getDocs(tablesQuery);
      const tableIds = tablesSnapshot.docs.map(doc => doc.data().tableId);
      console.log('Order: Fetched assigned tables:', { selectedServiceArea, unitCode, tableIds });
      return tableIds;
    } catch (error) {
      console.error('Order: Error fetching assigned tables:', { selectedServiceArea, unitCode, error });
      setError(`Failed to fetch assigned tables: ${error.message}`);
      return [];
    }
  };

const getStorageKey = () => {
  return `addedItems_${companyCode}_${unitCode}_${tableId}_${selectedServiceArea}`;
};

useEffect(() => {
  const fetchGstPlans = async () => {
    if (!companyCode) return;

    const q = query(
      collection(db, "gstPlans"),
      where("companyCode", "==", companyCode)
    );

    const snapshot = await getDocs(q);

    const map = {};
    snapshot.forEach(doc => {
      const data = doc.data();
      map[data.gstName] = data; // key by gstName
    });

    setGstPlansMap(map);
  };

  fetchGstPlans();
}, [companyCode]);
const handleAddItem = () => {
    if (billingPreference === 0 && !isManagerRoute) {
    setError("Only manager can add items when billing is cashier-controlled.");
    return;
  }
  // Either itemCode or itemName must be provided
  if ((!itemCode && !itemName) || quantity < 1 || !selectedServiceArea) return;

  // Find the menu item by code or name
  /*const menuItem = itemCode
    ? menuItems.find(item => item.itemCode.toLowerCase() === itemCode.toLowerCase())
    : menuItems.find(item => item.name === itemName);*/

    const menuItem =
  menuItems.find(item => item.name === itemName) ||
  menuItems.find(item =>
    item.itemCode?.toLowerCase().startsWith(itemCode?.toLowerCase())
  );
  if (!menuItem) return;

  // Ensure we have the correct code & name
  const finalItemCode = menuItem.itemCode;
  const finalItemName = menuItem.name;

  const category = menuItem.category || "";
  const serviceAreaInfo = serviceAreasMap[selectedServiceArea];
  if (!serviceAreaInfo) {
    console.warn("Service area info not loaded yet!");
    return;
  }

  const categoryKey = serviceAreaInfo.category?.trim().toLowerCase();
  let unitPrice = menuItem.basePrice ?? 0;

  // Match category price if exists
  if (categoryKey && menuItem.categoryPrices) {
    const matchedPriceEntry = Object.entries(menuItem.categoryPrices).find(
      ([key, value]) => key.trim().toLowerCase() === categoryKey
    );
    if (matchedPriceEntry) {
      unitPrice = parseFloat(matchedPriceEntry[1]);
    }
  }

  /*const exists = addedItems.find(
    item => item.itemCode === finalItemCode && item.serviceArea === selectedServiceArea
  );*/
  const currentItems = guestItems[mainTab] || [];
 const exists = currentItems.find(
  item =>
    item.itemCode === finalItemCode &&
    item.serviceArea === selectedServiceArea &&
    item.status === "Ordered"
);

  const updatedItems = exists
    ? currentItems.map(item =>
        //item.itemCode === finalItemCode && item.serviceArea === selectedServiceArea
        item.itemCode === finalItemCode &&
      item.serviceArea === selectedServiceArea &&
      item.status === "Ordered"
          ? {
              ...item,
              id: menuItem.id, 
              quantity: item.quantity + quantity,
              price: parseFloat(unitPrice.toFixed(2)),
            totalPrice: parseFloat(((item.quantity + quantity) * unitPrice).toFixed(2)),
              //totalPrice: (item.quantity + quantity) * unitPrice,
              //price: unitPrice,
              status: "Ordered",
            }
          : item
      )
    : [
        ...currentItems,
        {
          id: menuItem.id,
          itemCode: finalItemCode,
          itemName: finalItemName,
          categoryName: category,
          imageUrl: menuItem.image || menuItem.imageUrl || "",
          quantity,
          serviceArea: selectedServiceArea,
          //price: unitPrice,
          //totalPrice: unitPrice * quantity,
          price: parseFloat(unitPrice.toFixed(2)),
        totalPrice: parseFloat((unitPrice * quantity).toFixed(2)),
          status: "Ordered",
          guestIndex: mainTab
        }
      ];

  console.log('Ordered Item:', {
    itemCode: finalItemCode,
    itemName: finalItemName,
    serviceArea: selectedServiceArea,
    category: serviceAreaInfo.category,
    menuItemCategoryPrices: menuItem.categoryPrices,
    finalUnitPrice: unitPrice
  });

  //setAddedItems(updatedItems);
  setGuestItems(prev => ({
  ...prev,
  [mainTab]: updatedItems
}));
  //sessionStorage.setItem(getStorageKey(), JSON.stringify(updatedItems));
  sessionStorage.setItem(
  `${getStorageKey()}_${mainTab}`,
  JSON.stringify(updatedItems)
);

  // Reset inputs
  setQuantity(1);
  setItemCode("");
  setItemName("");
  setInputStep("code");
};

/*useEffect(() => {
  if (!companyCode || !unitCode || !tableId || !selectedServiceArea) return;
  if (!orders.length) return;

  const latestOrder = orders
    .filter(o => o.tableId === tableId && o.guestIndex === mainTab)
    .sort((a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0))
    .slice(-1)[0];

  const isPaidBefore = latestOrder?.orderStatus === "Paid" && !showPaid;

  const isCancelledBefore = latestOrder?.orderStatus === "Cancelled" && !showCancelled;

  const isDeletedBefore = latestOrder?.orderStatus === "Deleted" && !showDeleted;
  if (isPaidBefore || isCancelledBefore || isDeletedBefore) {
    // Only clear items if Paid **before current session**
    sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);
    //setGuestItems({});
    setGuestItems(prev => ({
  ...prev,
  [mainTab]: []
}));
    setGuestTabs(prev => {
      const updated = [...prev];
      if (updated[mainTab]) {
        updated[mainTab].orderPreference = null;
      }
      return updated;
    });
    return;
  }

  // Restore normally
  const restoredGuestItems = {};
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith(getStorageKey())) {
      const tabIndex = key.split("_").pop();
      restoredGuestItems[tabIndex] = JSON.parse(sessionStorage.getItem(key));
    }
  });
  setGuestItems(restoredGuestItems);
}, [orders, companyCode, unitCode, tableId, selectedServiceArea, mainTab, showPaid, showCancelled, showDeleted ]);*/

useEffect(() => {
  if (!companyCode || !unitCode || !tableId || !selectedServiceArea) return;

  //  ALWAYS restore first (no dependency on orders)
  const restoredGuestItems = {};

  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith(getStorageKey())) {
      const tabIndex = key.split("_").pop();
      restoredGuestItems[tabIndex] = JSON.parse(sessionStorage.getItem(key));
    }
  });

  setGuestItems(restoredGuestItems);

}, [companyCode, unitCode, tableId, selectedServiceArea]);

useEffect(() => {
  if (!orders.length) return;

  const latestOrder = orders
    .filter(o => o.tableId === tableId && o.guestIndex === mainTab)
    .sort((a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0))
    .slice(-1)[0];

  const shouldClear =
    (latestOrder?.orderStatus === "Paid" && !showPaid) ||
    (latestOrder?.orderStatus === "Cancelled" && !showCancelled) ||
    (latestOrder?.orderStatus === "Deleted" && !showDeleted);

  if (shouldClear) {
    sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);

    setGuestItems(prev => ({
      ...prev,
      [mainTab]: []
    }));
  }

}, [orders, mainTab, showPaid, showCancelled, showDeleted]);
useEffect(() => {
  const flag = sessionStorage.getItem("showPaid");
  setShowPaid(flag === "true");
}, []);

useEffect(() => {
  const flag = sessionStorage.getItem("showCancelled");
  setShowCancelled(flag === "true");
}, []);

useEffect(() => {
  const flag = sessionStorage.getItem("showDeleted");
  setShowDeleted(flag === "true");
}, []);

useEffect(() => {
  // Reset all visibility flags when page loads fresh
  sessionStorage.removeItem("showPaid");
  sessionStorage.removeItem("showCancelled");
  sessionStorage.removeItem("showDeleted");

  setShowPaid(false);
  setShowCancelled(false);
  setShowDeleted(false);
}, []);
const handleRemoveItem = (itemToRemove) => {
  const currentItems = guestItems[mainTab] || [];

  const updatedItems = currentItems.filter(
    item =>
      !(
        item.itemCode === itemToRemove.itemCode &&
        item.serviceArea === itemToRemove.serviceArea &&
        item.status === "Ordered"
      )
  );

  setGuestItems(prev => ({
    ...prev,
    [mainTab]: updatedItems
  }));

  // update sessionStorage as well
  sessionStorage.setItem(
    `${getStorageKey()}_${mainTab}`,
    JSON.stringify(updatedItems)
  );
};

const handleCancelItem = async (itemToCancel) => {
  try {
    if (!currentOrder) return;

    const orderRef = doc(db, "orders", currentOrder.id);

    // Update only the clicked item
    const updatedItems = (currentOrder.items || []).map(item =>
      item.itemInstanceId === itemToCancel.itemInstanceId
        ? { ...item, status: "Cancelled" }
        : item
    );

    // Recalculate total (exclude cancelled items)
    const updatedTotal = updatedItems
      .filter(item => item.status !== "Cancelled")
      .reduce((sum, i) => sum + i.totalPrice, 0);

    await updateDoc(orderRef, {
      items: updatedItems,
      totalAmount: parseFloat(updatedTotal.toFixed(2))
    });

    console.log("Item cancelled successfully");

  } catch (err) {
    console.error("Cancel item error:", err);
  }
};

  useEffect(() => {
    console.log('Order: Initial state:', { state, userId, companyCode, unitCode, highlightOrderId, highlightItemId, query: location?.search });
    
    if (!companyCode || !userId || !unitCode) {
      console.error('Order: Missing required parameters, redirecting to login', { userId, companyCode, unitCode, query: location?.search });
      setError('Authentication or unit required. Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
      return;
    }

    sessionStorage.setItem('companyCode', companyCode);
    sessionStorage.setItem('userId', userId);
    sessionStorage.setItem('unitCode', unitCode);

    if (tableId) {
  sessionStorage.setItem("tableId", tableId);
}

 fetchMenuItems();

    let unsubscribe = () => {};
    const setupRealtimeListener = async () => {
      setIsLoading(true);
      try {
        const tableIds = await fetchAssignedTables();
        setAssignedTableIds(tableIds);
        console.log('Order: Setting up snapshot listener for companyCode:', companyCode, 'unitCode:', unitCode);

        const ordersQuery = query(
          collection(db, 'orders'),
          where('companyCode', '==', companyCode),
          where('unitCode', '==', unitCode),
          //where('tableId', 'in', tableIds.length > 0 ? tableIds : ['__dummy__']) // Prevent empty 'in' query
          where('tableId', '==', tableId),
          where('waiterId', '==', userId)
        );

        unsubscribe = onSnapshot(ordersQuery, (snapshot) => {
          try {
            console.log('Order: Received snapshot update, size:', snapshot.size);
            const ordersList = snapshot.docs
              .map(doc => ({ id: doc.id, ...doc.data() }))
              .filter(order => tableIds.includes(order.tableId))
              .sort((a, b) => {
                const aTime = a.createdAt instanceof Timestamp ? a.createdAt.toDate() : new Date(a.createdAt || 0);
                const bTime = b.createdAt instanceof Timestamp ? b.createdAt.toDate() : new Date(b.createdAt || 0);
                return aTime - bTime;
              });

            setOrders(ordersList);
            
            console.log('Order: Updated orders:', ordersList.map(o => ({
              orderId: o.orderId,
              tableId: o.tableId,
              unitCode: o.unitCode,
              status: o.status,
              items: o.items ? o.items.map(i => ({ itemInstanceId: i.itemInstanceId, id: i.id, name: i.name, status: i.status })) : []
            })));
            if (ordersList.length === 0) {
              console.log('Order: No orders found for companyCode:', companyCode, 'unitCode:', unitCode, 'tableIds:', tableIds);
            }
          } catch (err) {
            console.error('Order: Error processing snapshot:', err);
            setError(`Failed to load orders: ${err.message}`);
            setOrders([]);
          }
          setIsLoading(false);
        }, (err) => {
          console.error('Order: Snapshot listener error:', err);
          setError(`Failed to listen for order updates: ${err.message}`);
          setOrders([]);
          setIsLoading(false);
        });

        await fetchCompanyName();
      } catch (err) {
        console.error('Order: Error setting up listener:', err);
        setError(`Failed to initialize orders: ${err.message}`);
        setIsLoading(false);
      }

      return unsubscribe;
    };

    setupRealtimeListener().then(unsub => {
      unsubscribe = unsub;
    });

    return () => {
      console.log('Order: Cleaning up listener');
      unsubscribe();
    };
  }, [companyCode, userId, unitCode, navigate]);

  useEffect(() => {
    if (highlightOrderId && highlightItemId) {
      console.log('Order: Highlight received:', { highlightOrderId, highlightItemId });
      const order = orders.find(o => o.orderId === highlightOrderId);
      if (order) {
        const item = order.items?.find(i => i.itemInstanceId === highlightItemId && i.status === 'Ready');
        console.log('Order: Found order and item:', { orderId: order.orderId, itemInstanceId: highlightItemId, itemStatus: item?.status });
        if (item) {
          console.log('Order: Setting tabValue to Ready (0)');
          setTabValue(0); // Ready tab
          setTimeout(() => {
            const itemRef = itemRefs.current[`${highlightOrderId}_${highlightItemId}`];
            if (itemRef) {
              console.log('Order: Scrolling to item:', { orderId: highlightOrderId, itemInstanceId: highlightItemId });
              itemRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              console.log('Order: No ref found for item:', { orderId: highlightOrderId, itemInstanceId: highlightItemId });
            }
          }, 500);
        } else {
          console.log('Order: Item not found or not Ready:', { highlightItemId, orderStatus: order.status });
          setTabValue(1); // All tab as fallback
        }
      } else {
        console.log('Order: Order not found for highlightOrderId:', highlightOrderId);
      }
    }
  }, [highlightOrderId, highlightItemId, orders]);

  const handleTabChange = (event, newValue) => {
    console.log('Order: Changing tab to:', newValue);
    setTabValue(newValue);
  };

  /*const handleMarkItemDelivered = async (orderId, itemInstanceId) => {
    try {
      const order = orders.find(o => o.id === orderId);
      if (!order) {
        throw new Error('Order not found');
      }
      const targetItem = order.items.find(item => item.itemInstanceId === itemInstanceId);
      if (!targetItem) {
        throw new Error(`Item instance ${itemInstanceId} not found in order ${orderId}`);
      }
      const updatedItems = order.items.map(item =>
        item.itemInstanceId === itemInstanceId ? { ...item, status: 'Served' } : item
      );
      let orderStatus;
      if (updatedItems.every(item => item.status === 'Served')) {
        orderStatus = 'Served';

         // free the table
 // await updateTableStatus(order.tableId, "Active");

  const remainingOrders = orders.filter(o =>
    o.tableId === order.tableId &&
    o.items.some(item => item.status !== "Served")
  );

  if (remainingOrders.length === 0) {
    await updateTableStatus(order.tableId, "Available");
  }
      } else if (updatedItems.some(item => item.status === 'Confirmed')) {
        orderStatus = 'Confirmed';
      } else if (updatedItems.some(item => item.status === 'Preparing')) {
        orderStatus = 'Preparing';
      } else if (updatedItems.every(item => item.status === 'Ready')) {
        orderStatus = 'Ready';
      } else {
        orderStatus = order.status;
      }
      const orderDoc = doc(db, 'orders', orderId);
      await updateDoc(orderDoc, { 
        status: orderStatus,
        items: updatedItems
      });
      console.log(`Order: Marked item instance ${itemInstanceId} in order ${orderId} as Served, new order status: ${orderStatus}`);
    } catch (err) {
      console.error('Order: Error marking item as Served:', err);
      setError('Failed to update item status: ' + err.message);
    }
  };*/
  const handleMarkItemDelivered = async (orderId, itemInstanceId) => {
  try {
    const order = orders.find(o => o.id === orderId);
    if (!order) {
      throw new Error('Order not found');
    }

    const targetItem = order.items.find(item => item.itemInstanceId === itemInstanceId);
    if (!targetItem) {
      throw new Error(`Item instance ${itemInstanceId} not found in order ${orderId}`);
    }

    // Update ORDER items
    const updatedItems = order.items.map(item =>
      item.itemInstanceId === itemInstanceId
        ? { ...item, status: 'Served' }
        : item
    );

    let orderStatus;
    if (updatedItems.every(item => item.status === 'Served')) {
      orderStatus = 'Served';

      const remainingOrders = orders.filter(o =>
        o.tableId === order.tableId &&
        o.items.some(item => item.status !== "Served")
      );

      if (remainingOrders.length === 0) {
        await updateTableStatus(order.tableId, "Available");
      }

    } else if (updatedItems.some(item => item.status === 'Confirmed')) {
      orderStatus = 'Confirmed';
    } else if (updatedItems.some(item => item.status === 'Preparing')) {
      orderStatus = 'Preparing';
    } else if (updatedItems.every(item => item.status === 'Ready')) {
      orderStatus = 'Ready';
    } else {
      orderStatus = order.status;
    }

    const orderDoc = doc(db, 'orders', orderId);
    await updateDoc(orderDoc, {
      status: orderStatus,
      items: updatedItems
    });

        const cartQuery = query(
      collection(db, "carts"),
      where("orderId", "==", order.orderId) // match the cart by orderId
    );

    const cartSnapshot = await getDocs(cartQuery);

    /*const cartUpdatePromises = cartSnapshot.docs.map(cartDoc => {
      const cartData = cartDoc.data();

      const updatedCartItems = (cartData.items || []).map(cartItem =>
        cartItem.id === targetItem.id 
          ? { ...cartItem, status: 'Served' }
          : cartItem
      );

      return updateDoc(doc(db, "carts", cartDoc.id), {
        items: updatedCartItems,
        updatedAt: serverTimestamp()
      });
    });*/
    const cartUpdatePromises = cartSnapshot.docs.map(cartDoc => {
  const cartData = cartDoc.data();

  const updatedCartItems = (cartData.items || []).map(cartItem =>
    cartItem.id === targetItem.id
      ? { ...cartItem, status: 'Served' }
      : cartItem
  );

  let cartStatus;
  if (updatedCartItems.every(item => item.status === "Served")) {
    cartStatus = "Served";
  } else if (updatedCartItems.every(item => item.status === "Ready")) {
    cartStatus = "Ready";
  } else if (updatedCartItems.some(item => item.status === "Preparing")) {
    cartStatus = "Preparing";
  } else {
    cartStatus = "Confirmed";
  }

  return updateDoc(doc(db, "carts", cartDoc.id), {
    items: updatedCartItems,
    cartStatus: cartStatus,
    updatedAt: serverTimestamp()
  });
});

    await Promise.all(cartUpdatePromises);
    console.log("Order and  Cart synced for item:", targetItem.id);

  } catch (err) {
    console.error('Order: Error marking item as Served:', err);
    setError('Failed to update item status: ' + err.message);
  }
};

 /* const updateTableStatus = async (tableId, status) => {
  try {
    const tableDocId = `${companyCode}_${unitCode}_${tableId}`;
    const tableRef = doc(db, "tables", tableDocId);

    await updateDoc(tableRef, {
      tableStatus: status
    });

    console.log(`Order: Updated table ${tableId} status to ${status}`);
  } catch (error) {
    console.error("Order: Failed to update table status:", error);
  }
};*/
const updateTableStatus = async (tableId, status, occupied = false) => {
  try {
    const tableDocId = `${companyCode}_${unitCode}_${tableId}`;
    const tableRef = doc(db, "tables", tableDocId);

    await updateDoc(tableRef, {
      tableStatus: status,
      occupied: occupied
    });

    console.log(
      `Order: Updated table ${tableId} status to ${status}, occupied=${occupied}`
    );
  } catch (error) {
    console.error("Order: Failed to update table status:", error);
  }
};

 /* const handleBack = () => {
    console.log('Order: Navigating to /servers/home', { companyCode, unitCode, userId });
    sessionStorage.setItem('companyCode', companyCode);
    sessionStorage.setItem('unitCode', unitCode);
    sessionStorage.setItem('userId', userId);
    sessionStorage.removeItem("showPaid");
    sessionStorage.removeItem("showCancelled");
    sessionStorage.removeItem("showDeleted");
    navigate('/servers/home', { state: { companyCode, unitCode, userId } });
  };*/
  const handleBack = () => {
  console.log('Order: Going back');

  sessionStorage.setItem('companyCode', companyCode);
    sessionStorage.setItem('unitCode', unitCode);
    sessionStorage.setItem('userId', userId);
  sessionStorage.removeItem("showPaid");
    sessionStorage.removeItem("showCancelled");
    sessionStorage.removeItem("showDeleted");

  // If opened from manager page
  if (isManagerRoute && typeof onBack === "function") {
    onBack(); // goes back to manager Home
    return;
  }

  // Normal server flow
   navigate('/servers/home', { state: { companyCode, unitCode, userId } });
};

  const currentItems = guestItems[mainTab] || [];

const generateOrderId = () => {
  const randomPart = Math.random().toString(36).substring(2, 12).toUpperCase();
  return `${companyCode}_${unitCode}_${randomPart}`;
};


useEffect(() => {
  const fetchExistingOrder = async () => {
    if (!companyCode || !unitCode || !tableId) return;

    const q = query(
      collection(db, "orders"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode),
      where("tableId", "==", tableId)
    );

    const snapshot = await getDocs(q);

    if (snapshot.empty) return;

    setGuestTabs(prevTabs => {
      const updatedTabs = [...prevTabs];

      snapshot.forEach(docSnap => {
        const data = docSnap.data();
        const guestIndex = data.guestIndex ?? 0;

        if (updatedTabs[guestIndex]) {
          updatedTabs[guestIndex] = {
            ...updatedTabs[guestIndex],
            orderPreference: data.orderNo
          };
        }
      });

      return updatedTabs;
    });
  };

  fetchExistingOrder();
}, [companyCode, unitCode, tableId]);

const generateOrderNumber = async () => {

  const q = query(
    collection(db, "preferences"),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode),
    where("preferenceName", "==", "Order Number")
  );

  const snapshot = await getDocs(q);

  let orderNumber = "";

  snapshot.forEach(async (docSnap) => {

    const data = docSnap.data();
    const [prefix, counter] = data.preferenceValue.split(",");

    const padded = String(counter).padStart(2, "0");

    orderNumber = `${prefix}-${padded}`;

    const nextCounter = Number(counter) + 1;

    await updateDoc(doc(db, "preferences", docSnap.id), {
      preferenceValue: `${prefix},${nextCounter}`
    });

  });

  return orderNumber;
};
const createOrderWithMultipleItems = async (items) => {
  if (!companyCode || !unitCode || !tableId || !selectedServiceArea) {
    console.warn("Missing required info to create order");
    return null;
  }

  const currentCustomer = guestCustomers[mainTab];
const customerIdToUse = currentCustomer?.customerId || null;
  try {

    const q = query(
      collection(db, "orders"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode),
      where("tableId", "==", tableId),
       where("guestIndex", "==", mainTab)
    );

    const snapshot = await getDocs(q);

    let existingOrder = null;

// Get ALL orders sorted (latest last)
const allOrders = snapshot.docs
  .map(doc => ({ id: doc.id, ...doc.data() }))
  .sort((a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0));

// Latest order (even Cancelled/Deleted)
const lastOrder = allOrders.slice(-1)[0];

// Active order (only Open)
existingOrder = allOrders
  .filter(order => !["Deleted", "Cancelled", "Paid"].includes(order.orderStatus))
  .slice(-1)[0];

    // Prepare new items FIRST
    const newItems = items.map(item => ({
      itemInstanceId: `${item.id}_${Date.now()}_${Math.random()}` || item.itemInstanceId,
      id: item.id,
      itemCode: item.itemCode,
      name: item.itemName || item.name || "",
      imageUrl: item.imageUrl || "",
      quantity: item.quantity,
      price: parseFloat(item.price.toFixed(2)),
      totalPrice: parseFloat(item.totalPrice.toFixed(2)),
      serviceArea: item.serviceArea || selectedServiceArea || "",
      status: billingPreference === 0 || billingPreference === 1 ? "Served" : "Confirmed",
      guestIndex: mainTab,
      categoryName:
  item?.category ||
  item?.categoryName ||
  "Uncategorized",
      //cartId: item.cartId || null
    }));


    let orderIdToUse;
    let orderNo;
    const waiterName = userId?.split("#")[1] || "Unknown";
const magName = managerId?.split("#")[1] || "manager";

const selectedServerName =
  servers.find(s => s.userId === selectedServer)?.displayName || null;
//const orderUserid = isManagerRoute ? magName : waiterName;
const orderUserid = isManagerRoute
  ? (selectedServerName || managerName)
  : waiterName;
const label = isManagerRoute ? "Manager" : "Waiter";

      if (
  existingOrder &&
  !["Deleted", "Cancelled","Paid"].includes(existingOrder.orderStatus)
) {
  
  let updatedItems = [...existingOrder.items];

  newItems.forEach(newItem => {
    /*const idx = updatedItems.findIndex(
      item =>
        item.itemCode === newItem.itemCode &&
        item.serviceArea === newItem.serviceArea &&
        item.status === "Confirmed"
    );*/
    const idx = updatedItems.findIndex(item => {
  const isSameItem =
    item.itemCode === newItem.itemCode &&
    item.serviceArea === newItem.serviceArea;

  if (!isSameItem) return false;

  // ONLY for cart items → allow merging with Ready/Preparing
  if (newItem.source === "cart") {
    return ["Confirmed", "Preparing", "Ready"].includes(item.status);
  }

  //Normal items → keep old behavior
  return item.status === "Confirmed";
});

    if (idx > -1) {
      const existing = updatedItems[idx];
      const newQty = existing.quantity + newItem.quantity;
      updatedItems[idx] = {
        ...existing,
        quantity: newQty,
        totalPrice: parseFloat((existing.price * newQty).toFixed(2))
      };
    } else {
      updatedItems.push(newItem);
    }
  });

  const updatedTotal = updatedItems.reduce((sum, i) => sum + i.totalPrice, 0);

  await updateDoc(doc(db, "orders", existingOrder.id), {
    items: updatedItems,
    orderStatus: "Open",
    billingPreference,
    cartId: items[0]?.cartId || null,
    otp: items[0]?.otp || null, 
    totalAmount: parseFloat(updatedTotal.toFixed(2)),
    ...(customerIdToUse && { customerId: customerIdToUse })
  });

  orderIdToUse = existingOrder.orderId;
  orderNo = existingOrder.orderNo;

} else {

  const orderId = generateOrderId();

  //orderNo = lastOrder?.orderNo || await generateOrderNumber();
if (
  ["Paid", "Cancelled", "Deleted"].includes(lastOrder?.orderStatus)
) {
  
  orderNo = await generateOrderNumber();
} else if (lastOrder?.orderNo) {
  // Optional: reuse if still active (rare case)
  orderNo = lastOrder.orderNo;
} else {
  orderNo = await generateOrderNumber();
}
  const orderData = {
    orderId,
    orderNo,
    companyCode,
    unitCode,
    tableId,
    guestIndex: mainTab,
    waiterId: userId,
    managerId: orderUserid,
    //waiterId: isManagerRoute ? managerId : userId,
    cartId: items[0]?.cartId || null, 
    otp: items[0]?.otp || null, 
    status: billingPreference === 0 || billingPreference === 1 ? "Served" : "Confirmed",
    billingPreference,
    orderStatus: "Open",
    totalAmount: Number(
      items.reduce((sum, item) => sum + item.totalPrice, 0).toFixed(2)
    ),
    createdAt: serverTimestamp(),
    items: newItems,
    ...(customerIdToUse && { customerId: customerIdToUse })
  };
console.log("ORDER DATA:", orderData);
  await setDoc(doc(db, "orders", orderId), orderData);

  orderIdToUse = orderId;
}

   /* const menuItemsMap = new Map();
    menuItems.forEach(item => {
      menuItemsMap.set(item.id, item);
    });

    const itemsByStaff = new Map();

    newItems.forEach(item => {

      const menuItem = menuItemsMap.get(item.id);
      const staffId = menuItem?.staff || "default_kitchen_staff";

      if (!itemsByStaff.has(staffId)) {
        itemsByStaff.set(staffId, []);
      }

      itemsByStaff.get(staffId).push(item);
    });


    const notificationPromises = [];

    for (const [staffId, staffItems] of itemsByStaff.entries()) {

      const notificationId = `kitchen_${orderIdToUse}_${staffId}_${Date.now()}`;

      const itemsSummary = staffItems
        .map(item => `${item.name} (x${item.quantity})`)
        .join("; ");

      const notificationData = {
        orderId: orderIdToUse,
        tableId,
        companyCode,
        unitCode,
        userId: staffId,
        role: "kitchen_staff",
        message: `New order for Table ${tableId}: ${itemsSummary}`,
        createdAt: serverTimestamp(),
        read: false
      };

      notificationPromises.push(
        setDoc(doc(db, "notifications", notificationId), notificationData)
      );
    }

    await Promise.all(notificationPromises);*/

    //  SKIP notifications for cart items when billingPreference === 2
const shouldSkipKitchenNotification =
  billingPreference === 2 || billingPreference === 0 || billingPreference === 1;

if (!shouldSkipKitchenNotification) {

  const menuItemsMap = new Map();
  menuItems.forEach(item => {
    menuItemsMap.set(item.id, item);
  });

  const itemsByStaff = new Map();

  newItems.forEach(item => {
    const menuItem = menuItemsMap.get(item.id);
    const staffId = menuItem?.staff || "default_kitchen_staff";

    if (!itemsByStaff.has(staffId)) {
      itemsByStaff.set(staffId, []);
    }

    itemsByStaff.get(staffId).push(item);
  });

  const notificationPromises = [];

  for (const [staffId, staffItems] of itemsByStaff.entries()) {

    const notificationId = `kitchen_${orderIdToUse}_${staffId}_${Date.now()}`;

    const itemsSummary = staffItems
      .map(item => `${item.name} (x${item.quantity})`)
      .join("; ");

    const notificationData = {
      orderId: orderIdToUse,
      tableId,
      companyCode,
      unitCode,
      userId: staffId,
      role: "kitchen_staff",
      message: `New order for Table ${tableId}: ${itemsSummary}`,
      createdAt: serverTimestamp(),
      read: false
    };

    notificationPromises.push(
      setDoc(doc(db, "notifications", notificationId), notificationData)
    );
  }

  await Promise.all(notificationPromises);
}

// AUTO OCCUPY TABLE FOR DIRECT BILLING
if (billingPreference === 0 || billingPreference === 1) {
  await updateTableStatus(tableId, "Occupied", true);
}

sessionStorage.removeItem(
  `${getStorageKey()}_${mainTab}`
);
    //return orderIdToUse;
    return { orderId: orderIdToUse, orderNo };

  } catch (error) {
    console.error("Failed to create/update order:", error);
    setError("Failed to create order: " + error.message);
    return null;
  }
};

const updateOrderStatus = async (status, paymentMethod = null, transactionId = null) => {
  try {
    const q = query(
      collection(db, "orders"),
      where("companyCode", "==", companyCode),
      where("unitCode", "==", unitCode),
      where("tableId", "==", tableId),
      where("guestIndex", "==", mainTab)
    );

    const snapshot = await getDocs(q);

    /*const validOrder = snapshot.docs.find(
      doc => doc.data().orderStatus !== "Deleted"
    );*/
    const validOrder = snapshot.docs
  .map(doc => ({ ref: doc.ref, ...doc.data() }))
  .filter(order => !["Deleted"].includes(order.orderStatus))
  .sort((a, b) => (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0))
  .slice(-1)[0];

    if (!validOrder) {
      console.warn("No active order found");
      return;
    }

    const docRef = validOrder.ref;

    // GST Calculation (only when Paid)
let baseSubtotal = 0;
let totalCGST = 0;
let totalSGST = 0;

if (status === "Paid") {
  const items = validOrder.items || [];

  const menuItemsMap = new Map();
  menuItems.forEach(item => {
    menuItemsMap.set(item.id, item);
  });

  items.forEach(item => {
  if (item.status !== "Served") return;

  const quantity = item.quantity || 0;
  const price = item.price || 0;

  const menuItem = menuItemsMap.get(item.id);

  const gstPlanName = menuItem?.gstPlan;
  const gstPlan = gstPlansMap[gstPlanName];

  const gstPercent = gstPlan?.percentage ?? 0;
  const isInclusive = gstPlan?.inclusive ?? false;

  const gstRate = gstPercent / 100;

  let base = 0;
  let cgst = 0;
  let sgst = 0;

  if (isInclusive) {
    // PRICE INCLUDES GST → EXTRACT GST
    const total = price * quantity;

    base = total / (1 + gstRate);
    const gstAmount = total - base;

    cgst = gstAmount / 2;
    sgst = gstAmount / 2;

  } else {
    //  GST EXTRA
    base = price * quantity;

    cgst = base * (gstRate / 2);
    sgst = base * (gstRate / 2);
  }

  baseSubtotal += base;
  totalCGST += cgst;
  totalSGST += sgst;
});
}

const grandTotal = baseSubtotal + totalCGST + totalSGST;

let updatedItems = validOrder.items || [];

if (status === "Cancelled") {
  updatedItems = updatedItems.map(item => ({
    ...item,
    status: "Cancelled"
  }));
}
    await updateDoc(docRef, {
      orderStatus: status,
       items: updatedItems,
      ...(paymentMethod && { paymentMethod }),
       ...(transactionId && { transactionId }), 
         ...(status === "Paid" && {
    baseSubtotal: parseFloat(baseSubtotal.toFixed(2)),
    cgstTotal: parseFloat(totalCGST.toFixed(2)),
    sgstTotal: parseFloat(totalSGST.toFixed(2)),
    grandTotal: parseFloat(grandTotal.toFixed(2))
  })

    });

    console.log("Order status updated to:", status);

    // STORE PAYMENT RECORD
    if (status === "Paid") {

const paymentQuery = query(
  collection(db, "payments"),
  where("orderId", "==", validOrder.orderId)
);

const paymentSnapshot = await getDocs(paymentQuery);

if (paymentSnapshot.empty) {
  // No payment exists → create one

  const paymentDocId = `payment_${validOrder.orderId}_${Date.now()}`;

  await setDoc(doc(db, "payments", paymentDocId), {
    paymentDocId,
    orderId: validOrder.orderId,
    tableId: validOrder.tableId,
    companyCode,
    unitCode,
    amount: parseFloat(grandTotal.toFixed(2)),
    paymentMethod: paymentMethod || "Online",
    paymentId: transactionId || null,
    status: "success",
    date: serverTimestamp()
  });

  console.log(" Payment stored");
  console.log("Payment details:", {
    paymentDocId,
    orderId: validOrder.orderId,
    tableId: validOrder.tableId,
    companyCode,
    unitCode,
    amount: parseFloat(grandTotal.toFixed(2)),
    paymentMethod: paymentMethod || " ",
    paymentId: transactionId || null,
    status: "success",
    date: new Date().toISOString()
  });
} else {
  console.log(" Payment already exists → skipping duplicate");
}
    }
    /*if (status === "Paid") {
  // Find related carts using orderId
  const cartQuery = query(
    collection(db, "carts"),
    where("orderId", "==", validOrder.orderId)
  );

  const cartSnapshot = await getDocs(cartQuery);

  const deletePromises = cartSnapshot.docs.map(cartDoc =>
    deleteDoc(doc(db, "carts", cartDoc.id))
  );

  await Promise.all(deletePromises);

  console.log("Related cart documents deleted");

  // CHECK IF ANY OPEN ORDERS STILL EXIST FOR THIS TABLE
  const remainingOrdersQuery = query(
    collection(db, "orders"),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode),
    where("tableId", "==", tableId)
  );

  const remainingSnapshot = await getDocs(remainingOrdersQuery);

  const activeOrders = remainingSnapshot.docs.filter(docSnap => {
    const data = docSnap.data();

    return !["Paid", "Cancelled", "Deleted"].includes(data.orderStatus);
  });

  // IF NO ACTIVE ORDERS → FREE TABLE
  if (activeOrders.length === 0) {
    await updateTableStatus(tableId, "Available", false);
}
}*/

if (["Paid", "Cancelled"].includes(status)) {
  // DELETE RELATED CARTS
  const cartQuery = query(
    collection(db, "carts"),
    where("orderId", "==", validOrder.orderId)
  );

  const cartSnapshot = await getDocs(cartQuery);

  const deletePromises = cartSnapshot.docs.map(cartDoc =>
    deleteDoc(doc(db, "carts", cartDoc.id))
  );

  await Promise.all(deletePromises);

  console.log("Related cart documents deleted");

  // CHECK REMAINING ACTIVE ORDERS
  const remainingOrdersQuery = query(
    collection(db, "orders"),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode),
    where("tableId", "==", tableId)
  );

  const remainingSnapshot = await getDocs(remainingOrdersQuery);

  const activeOrders = remainingSnapshot.docs.filter(docSnap => {

    const data = docSnap.data();

    return ![
      "Paid",
      "Cancelled",
      "Deleted"
    ].includes(data.orderStatus);

  });

  // FREE TABLE IF NO ACTIVE ORDERS
  if (activeOrders.length === 0) {

    await updateTableStatus(
      tableId,
      "Available",
      false
    );

    console.log(
      "Table marked as Available"
    );
  }
}

if (status === "Paid") {
  sessionStorage.setItem("showPaid", "true");
  setShowPaid(true);

  setPaidSuccessOpen(true); 
  
}
/*if (status === "Cancelled") {
  sessionStorage.setItem("showCancelled", "true"); 
  setShowCancelled(true);
  setCancelSuccessOpen(true);
}*/
if (status === "Cancelled") {

  sessionStorage.setItem("showCancelled", "true");
  setShowCancelled(true);

  // Clear customer/session data
  sessionStorage.removeItem(getCustomerStorageKey());

  setGuestCustomers(prev => ({
    ...prev,
    [mainTab]: {
      phone: "",
      name: "",
      customerExists: false,
      customerId: null
    }
  }));

  // Clear guest items
  setGuestItems(prev => ({
    ...prev,
    [mainTab]: []
  }));

  sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);

  // Remove guest tab
  setGuestTabs(prev => {
    const updated = [...prev];

    if (mainTab !== 0) {
      updated.splice(mainTab, 1);
    } else {
      updated[0].orderPreference = null;
    }

    return updated;
  });

  setMainTab(0);

  // Navigate immediately
  if (isManagerRoute && typeof onBack === "function") {
    onBack();
  } else {
    navigate("/servers/home", {
      state: {
        companyCode,
        unitCode,
        userId
      }
    });
  }
}

if (status === "Deleted") {
  sessionStorage.setItem("showDeleted", "true"); 
  setShowDeleted(true);
  setDeleteSuccessOpen(true);
}
    // CLEAR UI when deleted
   if (status === "Deleted") {
      sessionStorage.setItem("showDeleted", "true");   
      setDeleteSuccessOpen(true);                    
      // clear items (same as your logic)
      setGuestItems(prev => ({
        ...prev,
        [mainTab]: []
      }));

      sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);
    }

  } catch (err) {
    console.error("Failed to update order status:", err);
  }
};

const handledPaymentsRef = useRef(new Set());
const [pendingDeleteOrderId, setPendingDeleteOrderId] = useState(null);

useEffect(() => {
  if (!companyCode || !unitCode || !tableId) return;

  const q = query(
    collection(db, "payments"),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode),
    where("tableId", "==", tableId),
    where("status", "==", "success")
  );

  const unsubscribe = onSnapshot(q, async (snapshot) => {
    for (const paymentDoc of snapshot.docs) {
      const paymentData = paymentDoc.data();

      if (handledPaymentsRef.current.has(paymentData.orderId)) continue;

      const orderQuery = query(
        collection(db, "orders"),
        where("orderId", "==", paymentData.orderId)
      );

      const orderSnap = await getDocs(orderQuery);

      for (const orderDoc of orderSnap.docs) {
        const orderData = orderDoc.data();

        /*if (orderData.orderStatus !== "Paid") */
        if (
  !["Paid", "Cancelled", "Deleted"].includes(orderData.orderStatus)
) {
          handledPaymentsRef.current.add(paymentData.orderId);

          await updateDoc(orderDoc.ref, {
            orderStatus: "Paid",
            paymentMethod: paymentData.paymentMethod || "Online",
            transactionId: paymentData.paymentId || null,
            updatedAt: serverTimestamp()
          });

          console.log("Order updated from payment:", paymentData.orderId);

          setPendingDeleteOrderId(paymentData.orderId);

          setPaidSuccessOpen(true);
          setShowPaid(true);
          sessionStorage.setItem("showPaid", "true");
        }
      }
    }
  });

  return () => unsubscribe();
}, [companyCode, unitCode, tableId]);
useEffect(() => {
  if (!companyCode || !unitCode || !tableId) return;

  const fetchGuestTabs = async () => {
    try {
      const q = query(
        collection(db, "orders"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("tableId", "==", tableId)
      );
      const snapshot = await getDocs(q);

      // Map guestIndex → orderNo
      const ordersByGuest = {};
      /*snapshot.docs.forEach(docSnap => {
  const data = docSnap.data();
  ordersByGuest[data.guestIndex] = data.orderNo || "";
});*/

snapshot.docs.forEach(docSnap => {
  const data = docSnap.data();

  // Ignore Paid / Deleted / Cancelled orders
  if (["Paid", "Deleted", "Cancelled"].includes(data.orderStatus)) return;

  ordersByGuest[data.guestIndex] = data.orderNo || "";
});

      // Build guestTabs array
      const maxIndex = Math.max(...Object.keys(ordersByGuest), 0);
      const tabs = [];

      for (let i = 0; i <= maxIndex; i++) {
        tabs.push({
          id: Date.now() + i, // unique id
          label: "New Order",
          orderPreference: ordersByGuest[i] || "", // show orderNo if exists
        });
      }

      // Always ensure there's at least one New Order tab
      if (tabs.length === 0) {
        tabs.push({ id: Date.now(), label: "New Order", orderPreference: "" });
      }

      setGuestTabs(tabs);

    } catch (err) {
      console.error("Failed to fetch guest tabs:", err);
    }
  };

  fetchGuestTabs();
}, [companyCode, unitCode, tableId]);

const generateUpiQr = async (unitCode, amount) => {
  try {
    const unitRef = doc(db, "units", unitCode);
    const unitSnap = await getDoc(unitRef);
    if (!unitSnap.exists()) return "";

    const unitData = unitSnap.data();
    const unitUpiDetails = unitData.upiDetails;
    if (!unitUpiDetails || unitUpiDetails.length === 0) return "";

    const upi = unitUpiDetails[0];

    const upiURL = `upi://pay?pa=${encodeURIComponent(upi.upiAddress)}&pn=${encodeURIComponent(upi.payeeName)}&tn=${encodeURIComponent(upi.description || "")}&am=${amount?.toFixed(2) || 0}&cu=INR`;

    const qrDataURL = await QRCode.toDataURL(upiURL, {
      errorCorrectionLevel: "H",
      type: "image/png",
      margin: 2,
      width: 150,
    });

    return qrDataURL;
  } catch (err) {
    console.error("Failed to generate QR code:", err);
    return "";
  }
};
const [qrDataURL, setQrDataURL] = useState("");

const menuMap = new Map();
menuItems.forEach(item => {
  menuMap.set(item.id, item);
});

const getOrCreateBillNo = async () => {

  if (!currentOrder?.id) return "";

  // If billNo already exists in order → reuse it
  /*if (currentOrder.billNo !== undefined && currentOrder.billNo !== null) {
    return currentOrder.billNo;
  }*/

   // Fetch latest order from Firestore
  const orderSnap = await getDoc(doc(db, "orders", currentOrder.id));

if (orderSnap.exists() && orderSnap.data()?.billNo) {
  return orderSnap.data().billNo;
}

  // Fetch Bill No preference
  const prefQuery = query(
    collection(db, "preferences"),
    where("companyCode", "==", companyCode),
    where("unitCode", "==", unitCode),
    where("preferenceName", "==", "Bill No")
  );

  const prefSnapshot = await getDocs(prefQuery);

  if (prefSnapshot.empty) {
    console.error("Bill No preference not found");
    return "";
  }

  const prefDoc = prefSnapshot.docs[0];

  const prefData = prefDoc.data();

  // current preference value
  /*const currentBillNo = Number(prefData.preferenceValue || 0);

  // Store THIS value in order
  const generatedBillNo = currentBillNo;

  // Increment preference for next bill
  await updateDoc(doc(db, "preferences", prefDoc.id), {
    preferenceValue: String(currentBillNo + 1)
  });*/
  const currentBillNo = Number(prefData.preferenceValue || 0);

// Generate next bill no
const generatedBillNo = currentBillNo + 1;

// Increment preference for next bill
await updateDoc(doc(db, "preferences", prefDoc.id), {
  preferenceValue: String(generatedBillNo)
});

  // Save bill no in order table
  if (!orderSnap.data()?.billNo) {
  await updateDoc(doc(db, "orders", currentOrder.id), {
    billNo: generatedBillNo,
    isActive: true
  });
}

  return generatedBillNo;
};

const handlePrintBill = async(paymentMethod = selectedPayment) => {
 
  // Filter only served items
  const items = tableItems.filter(
    item => (item.status || item.item?.status) === "Served"
  );

  if (items.length === 0) {
    alert("No served items to print.");
    return;
  }

  const finalPaymentMethod =
  typeof paymentMethod === "string" && paymentMethod
    ? paymentMethod
    : typeof currentOrder?.paymentMethod === "string"
    ? currentOrder.paymentMethod
    : "";

const aggregated = items.reduce((acc, item) => {
  const code = item.itemCode;

  const quantity = item.quantity || 0;
  const price = item.price || 0;

  const menuItem = menuMap.get(item.id);

  const gstPlanName = menuItem?.gstPlan;
  const gstPlan = gstPlansMap[gstPlanName];

  const gstPercent = gstPlan?.percentage ?? 0;
  const isInclusive = gstPlan?.inclusive ?? false;

  const gstRate = gstPercent / 100;

  let base = 0;
  let cgst = 0;
  let sgst = 0;

  if (isInclusive) {
    //  GST INCLUDED → EXTRACT
    const total = price * quantity;

    base = total / (1 + gstRate);
    const gstAmount = total - base;

    cgst = gstAmount / 2;
    sgst = gstAmount / 2;

  } else {
    //  GST EXTRA
    base = price * quantity;

    cgst = base * (gstRate / 2);
    sgst = base * (gstRate / 2);
  }

  if (!acc[code]) {
    acc[code] = {
      itemCode: code,
      categoryName: item.categoryName || "", // ADD THIS
      name: item.itemName || item.name,
      quantity: 0,
      price: price,
      baseTotal: 0,
      cgst: 0,
      sgst: 0
    };
  }

  acc[code].quantity += quantity;
  acc[code].baseTotal += base;
  acc[code].cgst += cgst;
  acc[code].sgst += sgst;

  return acc;
}, {});

  const aggregatedItems = Object.values(aggregated);
 // Check if preference exists
const shouldSeparateCategory =
  showCategorySeparate !== null &&
  showCategorySeparate !== undefined &&
  showCategorySeparate !== "";

// Get actual category name from preference option index
/*const selectedCategory =
  billingPreference?.preferenceOptions?.[
    billingPreference?.preferenceValue
  ]
    ?.trim()
    ?.toLowerCase() || "";*/
    const selectedCategory =
  categoryPreference?.preferenceOptions?.[
    showCategorySeparate
  ]
    ?.trim()
    ?.toLowerCase() || "";
  // Get category from order items
/*const getItemCategory = (aggregatedItem) => {

  const originalItem = items.find(
    i =>
      i.itemCode === aggregatedItem.itemCode ||
      i.name === aggregatedItem.name
  );

  return String(originalItem?.categoryName || "")
    .trim()
    .toLowerCase();
};*/

console.log("Selected Category:", selectedCategory);

console.log(
  "Aggregated Categories:",
  aggregatedItems.map(i => ({
    name: i.name,
    category: i.categoryName
  }))
);

const getItemCategory = (aggregatedItem) => {
  return String(aggregatedItem.categoryName || "")
    .trim()
    .toLowerCase();
};

// Separate category items
/*const separateCategoryItems = shouldSeparateCategory
  ? aggregatedItems.filter(item =>
      getItemCategory(item) === selectedCategory
    )
  : [];*/
  const separateCategoryItems = shouldSeparateCategory
  ? aggregatedItems.filter(item =>
      getItemCategory(item) === selectedCategory
    )
  : [];

// Remaining items
const normalItems = shouldSeparateCategory
  ? aggregatedItems.filter(item =>
      getItemCategory(item) !== selectedCategory
    )
  : aggregatedItems;

  console.log("Separate Items:", separateCategoryItems);
const baseSubtotal = aggregatedItems.reduce((s, i) => s + i.baseTotal, 0);
const totalCGST = aggregatedItems.reduce((s, i) => s + i.cgst, 0);
const totalSGST = aggregatedItems.reduce((s, i) => s + i.sgst, 0);

const grandTotal = baseSubtotal + totalCGST + totalSGST;

const billNo = await getOrCreateBillNo();
   const qr = await generateUpiQr(unitCode, grandTotal);
 const renderRows = (items) =>
  items.map((item) => `
    <tr>
      <td class="item-name">${item.name}</td>
      <td class="number">₹${item.price.toFixed(2)}</td>
      <td class="number">${item.quantity}</td>
      <td class="number">₹${(item.price * item.quantity).toFixed(2)}</td>
      ${itemWiseTax === 0 ? `
        <td class="number">₹${item.cgst.toFixed(2)}</td>
        <td class="number">₹${item.sgst.toFixed(2)}</td>
      ` : ""}
    </tr>
  `).join("");

let rows = "";

//  Normal bill if no preference
if (!shouldSeparateCategory) {

  rows = renderRows(aggregatedItems);

} else {

  rows = `

    ${renderRows(normalItems)}

    ${
  separateCategoryItems.length > 0
    ? `

      <!-- SPACE BETWEEN NORMAL ITEMS & CATEGORY ITEMS -->
      <tr>
        <td colspan="${itemWiseTax === 0 ? 6 : 4}"
            style="border:none; height:15px; background:white;">
        </td>
      </tr>

      <!-- CATEGORY HEADING -->
      <tr>
        <td colspan="${itemWiseTax === 0 ? 6 : 4}"
            style="
              font-weight:bold;
              text-align:left;
              background:#f0f0f0;
              padding:10px;
            ">
          ${
  categoryPreference?.preferenceOptions?.[
    showCategorySeparate
  ] || ""
}
        </td>
      </tr>

      ${renderRows(separateCategoryItems)}
    `
    : ""
}

  `;
}

const companyRef = doc(db, "companies", companyCode);
const companySnap = await getDoc(companyRef);

let companyPhone = "";

if (companySnap.exists()) {
  const companyData = companySnap.data();
  companyPhone = companyData.phone || "";
}
  const iframe = document.createElement("iframe");

iframe.style.position = "fixed";
iframe.style.right = "0";
iframe.style.bottom = "0";
iframe.style.width = "0";
iframe.style.height = "0";
iframe.style.border = "0";

document.body.appendChild(iframe);

const printWindow = iframe.contentWindow;

printWindow.document.open();

printWindow.document.close();

setTimeout(() => {
  printWindow.focus();
  printWindow.print();

  printWindow.onafterprint = () => {
    document.body.removeChild(iframe);
  };
}, 300);

  printWindow.document.write(`
  <html>
  <head>
    <title>Bill</title>
    <style>
 body {
  font-family: Arial, sans-serif;
  padding: 0;
  margin: 0;
  font-size: 14px;   /* BIGGER COMMON FONT */
  color: #000;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
 margin:0;
}

th, td {
  padding: 2px 0;
  font-size: 14px;   /* SAME SIZE */
  border: none;
}

thead tr {
  border-top: 1px dashed #000;
  border-bottom: 1px dashed #000;
}

tbody tr:last-child {
  border-bottom: 1px dashed #000;
}

.item-name {
  width: 52%;
  text-align: left;
  padding-left: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.number {
  width: 16%;
  text-align: right;
  white-space: nowrap;
  padding-right: 2px;
}

.bill-header {
  text-align: center;
  margin-bottom: 10px;
}

.bill-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

.bill-header div {
  margin-top: 3px;
  font-size: 14px;   /* SAME FONT SIZE */
}

.total {
  padding: 0 ;
  text-align: right;
  font-size: 14px;
}

.grand-total {
  font-weight: bold;
  font-size: 16px;
  margin: 4px 0;
}

.footer-message {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}

.qr {
  text-align: center;
}

.qr img {
  width: 120px;
  margin-top: 8px;
}
@media print and (max-width: 80mm) {

  body {
    width: 80mm;
    padding: 0;
    margin: 0;
    font-family: Arial, sans-serif;
    font-size: 11px;
    line-height: 1.2;
  }

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
   margin: 0;
  }

  th,
  td {
    padding: 1px 0;
    font-size: 11px;
  }

  .item-name {
    width: 52%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .number {
    width: 16%;
    text-align: right;
    white-space: nowrap;
  }

  .bill-header {
    text-align: center;
    margin-bottom: 5px;
  }

  .bill-header h2 {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
  }

  .bill-header div {
    margin-top: 1px;
    font-size: 11px;
  }

  thead tr {
    border-top: 1px dashed #000;
    border-bottom: 1px dashed #000;
  }

  tbody tr:last-child {
    border-bottom: 1px dashed #000;
  }

  .total {
   padding:0;
    text-align: right;
    font-size: 11px;
  }

  .grand-total {
    font-size: 13px;
    font-weight: bold;
    margin: 3px 0;
  }

  .footer-message {
    text-align: center;
    margin-top: 6px;
    font-size: 11px;
  }

  .qr {
    text-align: center;
  }

  .qr img {
    width: 90px;
    margin-top: 6px;
  }

  @page {
    size: 80mm auto;
     margin: 0 !important;
  }
}

</style>
  </head>
  <body>
  <div class="bill-header">
    <h2 style="margin:0;">${companyName || "Hotel"}</h2>
    ${
  city || companyPhone
    ? `
      <div style="
        font-size:15px;
        display:flex;
        justify-content:center;
        gap:5px;
        flex-wrap:wrap;
      ">
        ${city ? `<span>${city}</span>` : ""}
        ${companyPhone ? `<span>Ph: ${companyPhone}</span>` : ""}
      </div>
    `
    : ""
}
    ${gstin ? `<div><b>GSTIN:</b> ${gstin}</div>` : ""}
   <div><b>Bill No:</b> ${billNo}</div>
    ${
  currentOrder?.tableId || currentOrder?.waiterId
    ? `
      <div style="display:flex; justify-content:center; gap:20px;">
        ${
          currentOrder?.tableId
            ? `<span><b>Table:</b> ${currentOrder.tableId}</span>`
            : ""
        }

        ${
  billDisplayName
    ? `<span><b>${billUserLabel}:</b> ${billDisplayName}</span>`
    : ""
}
      </div>
    `
    : ""
}
    <div><b>Date:</b> ${new Date().toLocaleString()}</div>
${finalPaymentMethod ? `
  <div><b>Payment Method:</b> ${finalPaymentMethod}</div>
` : ""}
</div>
    <table>
      <thead>
        <tr>
          <th class="item-name">Items</th>
          <th class="number">Price</th>
          <th class="number">Qty</th>
          <th class="number">Amount</th>
          ${itemWiseTax === 0 ? `
  <th class="number">CGST</th>
  <th class="number">SGST</th>
` : ""}
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>
    <div class="total">
${(totalCGST > 0 || totalSGST > 0) ? `
  <div>Total CGST: ₹${totalCGST.toFixed(2)}</div>
  <div>Total SGST: ₹${totalSGST.toFixed(2)}</div>
` : ""}
      <h2 style="padding: 0; margin: 2px 0;">Grand Total: ₹${grandTotal.toFixed(2)}</h2>
    </div>
    ${qr ? `<div class="qr"><p>Pay via UPI:</p><img src="${qr}" alt="UPI QR Code" /></div>` : ""}
   <div class="footer-message">
  Thank you for dining with us. Visit again!
</div>
    <script>

  window.onafterprint = () => {
    window.close();
  };

</script>
  </body>
  </html>
  `);
  printWindow.document.close();
  //printWindow.print();

};

const grandTotal = (guestItems[mainTab] || [])
  .filter(item => item.status === "Ordered")
  .reduce((sum, item) => sum + Number(item.totalPrice ?? 0), 0)
  .toFixed(2);

  useEffect(() => {
  setItemCode("");
  setItemName("");
  setQuantity(1);
  setShowQtyControls(false);
}, [mainTab]);

const getStatusColor = (status) => {
  switch (status) {
    case "Ordered":
      return "lightgray";   // orange
    case "Confirmed":
      return "blue";      // blue
    case "Preparing":
      return "orange"; // purple
    case "Ready":
      return "lightgreen";   // green
    case "Served":
      return "darkgreen";   // grey
    default:
      return "default";
  }
};

  const filteredMenuItems = itemCode
  ? menuItems.filter(item =>
      item.itemCode.toLowerCase().startsWith(itemCode.toLowerCase())
    )
  : menuItems;

/*const handlePaidSuccessClose = () => {
  setPaidSuccessOpen(false);
  setShowPaid(false);

  sessionStorage.removeItem(getCustomerStorageKey());
  setGuestCustomers(prev => ({
  ...prev,
  [mainTab]: {
    phone: "",
    name: "",
    customerExists: false,
    customerId: null
  }
}));
  // Clear items for the paid guest
  setGuestItems(prev => ({
    ...prev,
    [mainTab]: []
  }));

  sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);

  // Remove the guest tab if it's not the first default guest
  setGuestTabs(prev => {
    const updated = [...prev];

    // Only remove tabs with index !== 0 (first guest remains)
    if (mainTab !== 0) {
      updated.splice(mainTab, 1);
    } else {
      // Reset first guest instead of removing
      updated[0].orderPreference = null;
    }

    return updated;
  });

  // Reset mainTab to first tab after removal
  setMainTab(0);
};*/

const handlePaidSuccessClose = async () => {
  setPaidSuccessOpen(false);
  setShowPaid(false);

  try {
    // DELETE CARTS AFTER USER CLOSES DIALOG
    if (pendingDeleteOrderId) {
      const cartQuery = query(
        collection(db, "carts"),
        where("orderId", "==", pendingDeleteOrderId)
      );

      const cartSnapshot = await getDocs(cartQuery);

      await Promise.all(
        cartSnapshot.docs.map(cartDoc =>
          deleteDoc(cartDoc.ref)
        )
      );

      console.log("Carts deleted AFTER dialog close");

      setPendingDeleteOrderId(null);
    }
  } catch (err) {
    console.error("Failed to delete carts:", err);
  }

  sessionStorage.removeItem(getCustomerStorageKey());

  setGuestCustomers(prev => ({
    ...prev,
    [mainTab]: {
      phone: "",
      name: "",
      customerExists: false,
      customerId: null
    }
  }));

  // Clear items for the paid guest
  setGuestItems(prev => ({
    ...prev,
    [mainTab]: []
  }));

  sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);

  // Remove the guest tab if it's not the first default guest
  setGuestTabs(prev => {
    const updated = [...prev];

    if (mainTab !== 0) {
      updated.splice(mainTab, 1);
    } else {
      updated[0].orderPreference = null;
    }

    return updated;
  });

  // Reset mainTab
  setMainTab(0);

  // NAVIGATION
  if (isManagerRoute && typeof onBack === "function") {
    onBack(); // manager home
  } else {
    navigate("/servers/home", {
      state: {
        companyCode,
        unitCode,
        userId
      }
    });
  }
};

const handleCancelledSuccessClose = () => {
  setCancelSuccessOpen(false);
  setShowCancelled(false);

  sessionStorage.removeItem(getCustomerStorageKey());
   setGuestCustomers(prev => ({
  ...prev,
  [mainTab]: {
    phone: "",
    name: "",
    customerExists: false,
    customerId: null
  }
}));

  // Clear items for the paid guest
  setGuestItems(prev => ({
    ...prev,
    [mainTab]: []
  }));

  sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);

  // Remove the guest tab if it's not the first default guest
  setGuestTabs(prev => {
    const updated = [...prev];

    // Only remove tabs with index !== 0 (first guest remains)
    if (mainTab !== 0) {
      updated.splice(mainTab, 1);
    } else {
      // Reset first guest instead of removing
      updated[0].orderPreference = null;
    }

    return updated;
  });

  // Reset mainTab to first tab after removal
  setMainTab(0);

  // NAVIGATION
  if (isManagerRoute && typeof onBack === "function") {
    onBack(); // manager home
  } else {
    navigate("/servers/home", {
      state: {
        companyCode,
        unitCode,
        userId
      }
    });
  }
};

const handleDeletedSuccessClose = () => {
  setDeleteSuccessOpen(false);
  setShowDeleted(false);

  // Clear items for the paid guest
  setGuestItems(prev => ({
    ...prev,
    [mainTab]: []
  }));

  sessionStorage.removeItem(`${getStorageKey()}_${mainTab}`);

  // Remove the guest tab if it's not the first default guest
  setGuestTabs(prev => {
    const updated = [...prev];

    // Only remove tabs with index !== 0 (first guest remains)
    if (mainTab !== 0) {
      updated.splice(mainTab, 1);
    } else {
      // Reset first guest instead of removing
      updated[0].orderPreference = null;
    }

    return updated;
  });

  // Reset mainTab to first tab after removal
  setMainTab(0);
};
const [showQtyControls, setShowQtyControls] = useState(false);
const [isSavingOrder, setIsSavingOrder] = useState(false);
const [isProcessingPayment, setIsProcessingPayment] = useState(false);
useEffect(() => {
  if (showQtyControls && qtyRef.current) {
    qtyRef.current.focus();
    qtyRef.current.select();
  }
}, [showQtyControls]);
//const serverName = userId?.split("#")[1] || 'Unknown Server';
//const userName = userId?.split("#")[1] || "Unknown";

const serverName = userId?.split("#")[1] || "Unknown";
const managerName = managerId?.split("#")[1] || "manager";


const displayName = isManagerRoute ? managerName : serverName;
const userLabel = isManagerRoute ? "Manager" : "Waiter";

const selectedServerName =
  servers.find(s => s.userId === selectedServer)?.displayName || "";

const billDisplayName = isManagerRoute
  ? (selectedServerName || managerName)
  : serverName;

const billUserLabel = isManagerRoute
  ? (selectedServerName ? "Waiter" : "Manager")
  : "Waiter";

console.log("managerId:", managerId);
console.log("session managerId:", sessionStorage.getItem("managerId"));
const visibleItems = addedItems.filter(item => item.status !== "Confirmed");
  //const statuses = ['Ready','Ordered','All'];
  const statuses = ['Ordered','Confirmed','Preparing','Ready','Served','All'];

const tableItems = React.useMemo(() => {
  const localItems = (guestItems[mainTab] || []).filter(
    item =>
      item.status === "Ordered" &&
      item.serviceArea === selectedServiceArea &&
      item.guestIndex === mainTab 
  );

  const firestoreItems = orders.flatMap(order =>
    order.tableId === tableId &&
    order.waiterId === userId &&
    !(order.orderStatus === "Paid" && !showPaid) && // 👈 KEY FIX
    !(order.orderStatus === "Cancelled" && !showCancelled) &&
    !(order.orderStatus === "Deleted" && !showDeleted)
      ? (order.items || []).filter(
          item =>
            item.guestIndex === mainTab &&
            item.serviceArea === selectedServiceArea
        )
      : []
  );

  /*const cartItems = liveCartOrders.flatMap(cart =>
  cart.items.map(item => ({
    ...item,
    cartId: cart.id,
    source: "cart"
  }))
);*/
/*const cartItems = liveCartOrders.flatMap(cart => {
  const tabIndex = cartTabMap[cart.id];

  return cart.items.map(item => ({
    ...item,
    cartId: cart.id,
    guestIndex: tabIndex,
    source: "cart"
  }));
});

const filteredCartItems = cartItems.filter(
  item => item.guestIndex === mainTab
);*/

const filteredCartItems = liveCartOrders.flatMap(cart => {
  const tabIndex = cartTabMap[cart.id];
  if (tabIndex === undefined) return [];
  if (tabIndex !== mainTab) return [];

  return (cart.items || [])
    .filter(item => item.status === "Ordered") 
    .map(item => ({
      ...item,
      cartId: cart.id,
      guestIndex: tabIndex,
      source: "cart"
    }));
});

  const combined = [...firestoreItems, ...filteredCartItems]; // Start with Firestore items

  // Merge localItems into existing items if same itemCode + serviceArea
  localItems.forEach(localItem => {
  // Merge only with Confirmed items
 
const existingIndex = combined.findIndex(fItem => {
  const isSameItem =
    fItem.itemCode === localItem.itemCode &&
    fItem.serviceArea === localItem.serviceArea;

  if (!isSameItem) return false;

  const validStatuses = ["Confirmed", "Preparing", "Ready", "Served"];

  // Only consider mergeable statuses
  if (!validStatuses.includes(fItem.status)) return false;

  return (fItem.cartId || null) === (localItem.cartId || null);
});

  if (existingIndex > -1) {
    // Update quantity & totalPrice
    const existing = combined[existingIndex];
    const newQty = existing.quantity + localItem.quantity;
    combined[existingIndex] = {
      ...existing,
      quantity: newQty,
      totalPrice: parseFloat((existing.price * newQty).toFixed(2))
    };
  } else {
    // No matching Confirmed item → keep as Ordered
    combined.push(localItem);
  }
});

  return combined;
}, [guestItems, orders, mainTab, tableId, selectedServiceArea, showPaid, liveCartOrders, cartTabMap]);

const servedItems = tableItems.filter(
  item => (item.status || item.item?.status) === "Served"
);

// Aggregate like bill
const aggregated = servedItems.reduce((acc, item) => {
  const code = item.itemCode;

  const quantity = item.quantity || 0;
  const price = item.price || 0;
  //const base = price * quantity;

  const menuItem = menuMap.get(item.id);

  const gstPlanName = menuItem?.gstPlan;
  const gstPlan = gstPlansMap[gstPlanName];

  const gstPercent = gstPlan?.percentage ?? 0;
  const isInclusive = gstPlan?.inclusive ?? false;

  const gstRate = gstPercent / 100;

  let base = 0;
  let cgst = 0;
  let sgst = 0;

  if (isInclusive) {
    //  GST INCLUDED → EXTRACT
    const total = price * quantity;

    base = total / (1 + gstRate);
    const gstAmount = total - base;

    cgst = gstAmount / 2;
    sgst = gstAmount / 2;

  } else {
    //  GST EXTRA
    base = price * quantity;

    cgst = base * (gstRate / 2);
    sgst = base * (gstRate / 2);
  }

  if (!acc[code]) {
    acc[code] = {
      name: item.itemName || item.name,
      quantity: 0,
      baseTotal: 0,
      cgst: 0,
      sgst: 0
    };
  }

  acc[code].quantity += quantity;
  acc[code].baseTotal += base;
  acc[code].cgst += cgst;
  acc[code].sgst += sgst;

  return acc;

}, {});


const aggregatedItems = Object.values(aggregated);

const baseSubtotal = aggregatedItems.reduce((sum, i) => sum + i.baseTotal, 0);
const cgstTotal = aggregatedItems.reduce((sum, i) => sum + i.cgst, 0);
const sgstTotal = aggregatedItems.reduce((sum, i) => sum + i.sgst, 0);

const grandTotalBill = baseSubtotal + cgstTotal + sgstTotal;
const shouldHideItems = billingPreference === 0 && !isManagerRoute;
const currentOrder = orders
  .filter(o =>
    o.tableId === tableId &&
    o.guestIndex === mainTab &&
    !["Paid", "Cancelled", "Deleted"].includes(o.orderStatus)
    //!["Deleted"].includes(o.orderStatus)
  )
  .sort((a, b) => {
    return (a.createdAt?.seconds || 0) - (b.createdAt?.seconds || 0);
  })
  .slice(-1)[0]; 

const currentItem = guestItems[mainTab] || [];

/*const hasOrderedItems = currentItem.some(item => item.status === "Ordered");*/
const hasOrderedItems =
  (guestItems[mainTab] || []).some(item => item.status === "Ordered") ||
  liveCartOrders.some(cart =>
    cart.items?.some(item => item.status === "Ordered")
  );
const allServed =
  tableItems.filter(item =>
    !["Paid", "Cancelled", "Deleted"].includes(item.orderStatus)
  ).length > 0 &&
  tableItems
    .filter(item =>
      !["Paid", "Cancelled", "Deleted"].includes(item.orderStatus)
    )
    .every(item => (item.status || item.item?.status) === "Served");

  const currentTabCartIds = liveCartOrders
  .filter(cart => {
    const isCurrentTab = cartTabMap[cart.id] === mainTab;

    // Find matching order
    const relatedOrder = orders.find(
      o => o.orderId === cart.orderId
    );

    // If no order yet → show OTP
    if (!relatedOrder) return isCurrentTab;

    // Show OTP only if NOT Paid
    return isCurrentTab && relatedOrder.orderStatus !== "Paid";
  })
  .map(cart => cart.cartId);
  return (
    <>
    <Container maxWidth="lg" sx={{ bgcolor: darkMode ? '#1e1e2f' : '#f9fafb',
       py: { xs: 1.5, sm: 2, md: 3 },
    px: { xs: 1, sm: 2 }
     }}>
   <Box
 sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", md: "center" },
    gap: 1.5,
    mb: 3
  }}
>
  {/* Left Side - Waiter and Table */}
   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  <Typography
    variant="h6"
    sx={{ color: darkMode ? "#9ca3af" : "#4b5563", fontWeight: 500 }}
  >
    {/*Waiter: {serverName}*/}{userLabel}: {displayName} | Table: {tableId ? tableId : "All Tables"}
  </Typography>

   <Button
      variant="contained"
      size="small"
      sx={{
        textTransform: "none",
        bgcolor: darkMode ? "#8284f7" : "#918cf3",
        "&:hover": { bgcolor: darkMode ? "#4f46e5" : "#4338ca" },
      }}
    onClick={handleNewGuest}
    >
      New Guest
    </Button>
    </Box>

  {/* Right Side - Company and Unit */}
  <Typography
    variant="h6"
    sx={{ color: darkMode ? "#d1d5db" : "#1f2937", fontWeight: "bold" }}
  >
    {companyName || "Unknown Company"} - {unitName}
  </Typography>
</Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2, bgcolor: darkMode ? '#4b4b6e' : '#fee2e2', color: darkMode ? '#d1d5db' : '#b91c1c' }}>
          {error}
        </Alert>
      )}

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress sx={{ color: darkMode ? '#93c5fd' : '#735DA5' }} />
          <Typography variant="body1" sx={{ ml: 2, color: darkMode ? '#d1d5db' : '#1f2937' }}>
            Loading orders...
          </Typography>
        </Box>
      ) : (
        <>
        
       
         <Box sx={{ mb: 3 }}>
  <Tabs
    value={mainTab}
    onChange={(e, val) => setMainTab(val)}
    variant="scrollable"
  scrollButtons="auto"
    sx={{
      justifyContent: "flex-start",
      '& .MuiTab-root': {
        fontWeight: 'bold',
        textTransform: 'none',
        mr: 2,
        color: darkMode ? '#d1d5db' : '#1f2937',
        '&.Mui-selected': { color: darkMode ? '#a583f2' : '#735DA5' },
      },
      '& .MuiTabs-indicator': { bgcolor: darkMode ? '#a583f2' : '#735DA5' },
    }}
  >
   
 {guestTabs.map((guest, index) => {

  const localItems = (guestItems[index] || []).filter(
    item => item.status === "Ordered" && item.serviceArea === selectedServiceArea
     && item.guestIndex === index && item.tableId === tableId
  );

  const firestoreItems = orders.flatMap(order =>
    order.tableId === tableId
      ? (order.items?.filter(
          item =>
            item.guestIndex === index &&
            item.serviceArea === selectedServiceArea 
            
        ) || [])
      : []
  );

  const hasItems = localItems.length > 0 || firestoreItems.length > 0;

  /*const label = hasItems
    ? (guest.orderPreference || guest.label)
    : "New Order";*/

    const label = hasItems && guest.orderPreference && !isServerBlocked
  ? guest.orderPreference
  : "New Order";

  return (
    <Tab
      key={guest.id}
      label={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5
          }}
        >
          <span>{label}</span>

          {/* Only show close button if NOT the first tab */}
          {index !== 0 && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation(); // prevent tab change
                handleCloseGuest(index);
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      }
    />
  );
})}
  </Tabs>
</Box>
{profileData !== 1 && (
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: 2,
    mb: 2
  }}
>
  {/* Phone Number */}
  <TextField
    label="Phone Number"
    variant="standard"
    //value={customerPhone}
    //onChange={(e) => setCustomerPhone(e.target.value)}
    
    value={guestCustomers[mainTab]?.phone ?? ""}
onChange={(e) => {
   let value = e.target.value;

    value = value.replace(/\D/g, "");
  setGuestCustomers(prev => ({
    ...prev,
    [mainTab]: {
      ...prev[mainTab],
      phone: value
    }
  }));
}}
    inputProps={{ maxLength: 10 }}
  />
 
  {/* Customer Name */}
  <TextField
    label="Customer Name"
    variant="standard"
    //value={customerName}
    //onChange={(e) => setCustomerName(e.target.value)}
    value={guestCustomers[mainTab]?.name || ""}
onChange={(e) => {
  const value = e.target.value;
  setGuestCustomers(prev => ({
    ...prev,
    [mainTab]: {
      ...prev[mainTab],
      name: value
    }
  }));
}}
   // disabled={customerExists}
    disabled={guestCustomers[mainTab]?.customerExists}
  />

  {/* Save Button */}
  {!currentCustomer.customerExists &&
 currentCustomer.phone?.length === 10 &&
 currentCustomer.name && (
  <Button
    variant="contained"
    size="small"
    sx={{ height: 36, mt: 1 }}
    onClick={handleSaveCustomer}
  >
    Save
  </Button>
)}

  {/* Loading */}
  {checkingCustomer && (
    <CircularProgress size={20} />
  )}

  {currentTabCartIds.length > 0 && (
    <Typography variant="body2" sx={{ mt: 2 }}>
      Guest OTP{currentTabCartIds.length > 1 ? "s" : ""}:{" "}
      {currentTabCartIds.join(", ")}
    </Typography>
  )}
</Box>
)}

{/*{isManagerRoute && (
  <Autocomplete
  ref={serverSelectRef}
    size="small"
    options={sortedServers}
    value={
      sortedServers.find(s => s.userId === selectedServer) || null
    }
    onChange={(event, newValue) => {
      setSelectedServer(newValue?.userId || "");
       setTimeout(() => {
      itemCodeRef.current?.focus();
    }, 50);
    }}
     onKeyDown={(event) => {
    if (event.key === "Enter") {
      setTimeout(() => {
        itemCodeRef.current?.focus();
      }, 50);
    }
  }}
    getOptionLabel={(option) =>
      option.userId?.includes("#")
        ? option.userId.split("#")[1]
        : option.userId
    }
    isOptionEqualToValue={(option, value) =>
      option.userId === value.userId
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label="Waiter"
        variant="outlined"
        sx={{ width: 180 }} 
      />
    )}
    sx={{ minWidth: 180, mb: 2 }}
  />
)}*/}
{isManagerRoute && (
<Autocomplete
  ref={serverSelectRef}
  size="small"
  options={sortedServers}

  value={
    sortedServers.find(s => s.userId === selectedServer) || null
  }

  inputValue={serverInput}

onInputChange={(event, newInputValue) => {
  setServerInput(newInputValue);

  const matches = sortedServers.filter(
    s =>
      getServerLabel(s)
        .toLowerCase()
        .startsWith(newInputValue.toLowerCase())
  );

  if (matches.length === 1) {
    setSelectedServer(matches[0].userId);
  } else {
    setSelectedServer(""); // optional: clear if ambiguous
  }
}}
  onChange={(event, newValue) => {
    if (newValue) {
      setSelectedServer(newValue.userId);
      setServerInput(getServerLabel(newValue));
    }
  }}

  onKeyDown={(event) => {
    if (event.key === "Enter") {

    const matches = sortedServers.filter(
      s =>
        getServerLabel(s)
          .toLowerCase()
          .startsWith(serverInput.toLowerCase())
    );

    if (matches.length === 1) {
      setSelectedServer(matches[0].userId);
      setServerInput(getServerLabel(matches[0]));

      setTimeout(() => {
        itemCodeRef.current?.focus();
      }, 50);
    }
    }
  }}

  getOptionLabel={(option) => getServerLabel(option)}

  isOptionEqualToValue={(option, value) =>
    option.userId === value.userId
  }

  renderInput={(params) => (
    <TextField
      {...params}
      label="Waiter"
      variant="outlined"
      sx={{ width: 180 }}
    />
  )}
/>
)}
    <Box sx={{ mt: 2 }}>
      <Box
        sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: 2,
    alignItems: { xs: "stretch", sm: "center" },
    mt: 1,
    mb: 2
  }}
      >
        <TextField
          inputRef={itemCodeRef}
          label="Item Code"
          variant="standard"
          size="small"
          value={itemCode}
          //onChange={(e) => setItemCode(e.target.value)}
          onChange={(e) => {
  setItemCode(e.target.value);
  setInputStep("code");
}}
        />

         <FormControl variant="standard" sx={{ minWidth: 140 }}>
      <InputLabel shrink={false} sx={{ display: itemName ? "none" : "block" }}>
        Item Name
      </InputLabel>

      <Select
        value={itemName}
        //onChange={(e) => setItemName(e.target.value)}
        /*onChange={(e) => {
  setItemName(e.target.value);
  setShowQtyControls(true);   // show quantity automatically
}}*/
  //ref={selectRef}
  open={selectOpen}
  onOpen={() => setSelectOpen(true)}
  onClose={() => setSelectOpen(false)}
onChange={(e) => {
  setItemName(e.target.value);
  setShowQtyControls(true);
  setInputStep("qty");
setSelectOpen(false);
  setTimeout(() => {
    qtyRef.current?.focus();
  }, 50);
}}
        disableUnderline
      >
        {filteredMenuItems.length === 0 ? (
    <MenuItem disabled>
      <em>No Data</em>
    </MenuItem>
  ) : (
    filteredMenuItems.map((item) => (
      <MenuItem key={item.id} value={item.name}>
        {item.name}
      </MenuItem>
    ))
  )}
      </Select>
    </FormControl>

        <Box
      onClick={(e) => {
        e.stopPropagation();
        setShowQtyControls(prev => !prev);
      }}
     
      tabIndex={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer"
      }}
    >
     {!showQtyControls ? (
  
  <Typography variant="outline" color={darkMode ? "#9ca3af" : "text.secondary"}>
    Quantity
  </Typography>
) : (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    
    <IconButton
      size="small"
      sx={{ p: 0.3 }}
      onClick={(e) => {
        e.stopPropagation();
        decreaseQty();
      }}
    >
      <RemoveIcon sx={{ fontSize: 14 }} />
    </IconButton>
    <TextField
  inputRef={qtyRef}
  type="number"
  value={quantity}
  onClick={(e) => e.stopPropagation()}
  onChange={(e) => {
    const val = e.target.value;

    if (val === "") {
      setQuantity("");
    } else {
      setQuantity(Number(val));
    }
  }}
  onBlur={() => {
    if (!quantity || quantity < 1) setQuantity(1);
  }}
  size="small"
  variant="standard"
  inputProps={{
    min: 1,
    style: { textAlign: "center", width: 40 }
  }}
/>

    <IconButton
      size="small"
      sx={{ p: 0.3 }}
      onClick={(e) => {
        e.stopPropagation();
        increaseQty();
      }}
    >
      <AddIcon sx={{ fontSize: 14 }} />
    </IconButton>

    <Button
      size="small"
      variant="contained"
      sx={{
        minWidth: 40,
        height: 28,
        fontSize: 12,
        bgcolor: darkMode ? "#6b7280" : "#735DA5",
        "&:hover": { bgcolor: darkMode ? "#9ca3af" : "#a583f2" }
      }}
      disabled={isServerBlocked}
      onClick={(e) => {
        e.stopPropagation();
        handleAddItem();
        setShowQtyControls(false);

        setTimeout(() => {
          itemCodeRef.current?.focus();
        }, 50);
      }}
    >
      Add
    </Button>
      </Box>
      )}
      </Box>
      </Box>
</Box>
   {!shouldHideItems && tableItems.length > 0 && (
    <>
<List>
  {tableItems.map((item, index) => (
    <React.Fragment key={`${item.orderId || "local"}_${index}`}>
      <ListItem
        sx={{
    flexDirection: "column",
    alignItems: "flex-start",
    p: { xs: 1.5, sm: 2 },
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    mb: 2,
    backgroundColor: "#fafafa"
  }}
      >
        <Box 
         sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    gap: 1,
    width: "100%"
  }}
        >
 <img
                    src={item.imageUrl}
                    alt={item.name}
                    style={{ width: 90, height: 90, marginRight: 16, objectFit: 'cover', borderRadius: '4px' }}
                    onError={(e) => { e.target.src = '/placeholder.png'; }}
                  />
          {/* Item Details */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {item.name || item.itemName}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Item Code: {item.itemCode}
            </Typography>

            <Typography variant="body2" sx={{ fontWeight: 500 }}>
  ₹ {(item.price ?? 0).toFixed(2)} × {item.quantity} = ₹ {(item.totalPrice ?? 0).toFixed(2)}
</Typography>
          </Box>

          {/* Status */}
          <Chip
            label={item.status || "Ordered"}
            //color={getStatusColor(item.status || "Ordered")}
            sx={{
    backgroundColor: getStatusColor(item.status || "Ordered"),
    color: "#fff"
  }}
            size="small"
          />

          {item.status === "Ordered" && (
  <Button
    size="small"
    color="error"
    variant="outlined"
    sx={{ ml: 1 }}
    onClick={() => handleRemoveItem(item)}
  >
    Remove
  </Button>
)}

{item.status === "Served" && (billingPreference === 0 || billingPreference === 1 || billingPreference === 2 || billingPreference === 3) && (
  <Button
    size="small"
    color="error"
    variant="outlined"
    sx={{ ml: 1 }}
    onClick={() => handleCancelItem(item)}
  >
    Cancel
  </Button>
)}

{(
  item.status === "Ready" ||
  (billingPreference === 2 && item.status === "Confirmed")
) && (
  <Button
    size="small"
    variant="contained"
    sx={{
      bgcolor: darkMode ? "#6b7280" : "#735DA5",
      "&:hover": { bgcolor: darkMode ? "#9ca3af" : "#a583f2" }
    }}
    onClick={() =>
  handleMarkItemDelivered(
    item.orderId || currentOrder?.orderId,
    item.itemInstanceId
  )
}
  >
    Mark as Item Served
  </Button>
)}
{/*
{item.status === "Served" && currentOrder?.orderStatus === "Paid" && (
  <Chip label="Paid" color="success" size="small" />
)}*/}

{/*
{item.status === "Served" && currentOrder?.orderStatus === "Cancelled" && (
  <Chip label="Cancelled" color="warning" size="small" />
)}*/}

{item.status === "Served" && currentOrder?.orderStatus === "Deleted" && (
  <Chip label="Deleted" color="error" size="small" />
)}

        </Box>
      </ListItem>

      {index < tableItems.length - 1 && <Divider />}
    </React.Fragment>
  ))}
</List>

{servedItems.length > 0 && (
  <Box
    sx={{
      p: 0,
      minWidth: "300px",
      width: "fit-content", // important
      ml: "auto",           // pushes to right
    }}
  >
    <Typography variant="body1">
      <b>Base Subtotal:</b> ₹{baseSubtotal.toFixed(2)}
    </Typography>

{cgstTotal > 0 && (
      <Typography variant="body1">
        <b>CGST:</b> ₹{cgstTotal.toFixed(2)}
      </Typography>
    )}

    {sgstTotal > 0 && (
      <Typography variant="body1">
        <b>SGST:</b> ₹{sgstTotal.toFixed(2)}
      </Typography>
    )}
    <Typography variant="h6" sx={{ mt: 1 }}>
      <b>Grand Total:</b> ₹{grandTotalBill.toFixed(2)}
    </Typography>
  </Box>
)}
<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mt: 2
  }}
>
   <Button
          variant="contained"
          color="success"
           fullWidth
  //sx={{ maxWidth: { sm: 200 } }}
   sx={{
    maxWidth: { sm: 200 },
    bgcolor: allServed
      ? (darkMode ? "#535e74" : "#cbd5e1")   // disabled color
      : undefined,
    color: allServed ? "#fff" : undefined,
    cursor: allServed ? "not-allowed" : "pointer",
    "&:hover": {
      bgcolor: allServed
        ? (darkMode ? "#6b7280" : "#cbd5e1")
        : undefined,
    },
  }}
  disabled={isServerBlocked || allServed || !hasOrderedItems || isSavingOrder}
          onClick={async () => {
 if (confirmLockRef.current || isSavingOrder) return;

  confirmLockRef.current = true;
  setIsSavingOrder(true);
 try {
            const currentItems = guestItems[mainTab] || [];
            const localItems  =
              currentItems.filter(item => item.status === "Ordered");

   const cartItems = liveCartOrders
  .filter(cart => cartTabMap[cart.id] === mainTab)
  .flatMap(cart =>
    (cart.items || [])
      .filter(item => item.status === "Ordered") //ONLY NEW ITEMS
      .map(item => ({
        id: item.id,
        itemInstanceId: item.itemInstanceId,
        itemCode: item.itemCode,
        categoryName: item.category || item.categoryName || "",
        itemName: item.name || "",
        imageUrl: item.imageUrl || "",
        quantity: item.quantity,
        price: item.price,
        totalPrice: item.totalPrice,
        serviceArea: item.serviceArea || selectedServiceArea || "",
        status: "Ordered",
        guestIndex: mainTab,
        cartId: cart.id,
        otp: cart.cartId
      }))
  );

     const itemsToConfirm = [...localItems, ...cartItems];

  //if (itemsToConfirm.length === 0) return;
            //const orderId = await createOrderWithMultipleItems(itemsToConfirm);
if (itemsToConfirm.length === 0) {
        setIsSavingOrder(false);
        return;
      }
            const result =
  await createOrderWithMultipleItems(itemsToConfirm);
        
           if (result) {

  const { orderId, orderNo } = result;

  //setOrderPreference(orderNo); 

const updateCartPromises = liveCartOrders
  .filter(cart => cartTabMap[cart.id] === mainTab) 
  .map(async (cart) => {
  const cartRef = doc(db, "carts", cart.id);
  const cartSnap = await getDoc(cartRef);
  if (!cartSnap.exists()) return;

  const cartData = cartSnap.data();
  /*const updatedItems = (cartData.items || []).map(item => ({
    ...item,
    status: "Confirmed",
    orderId: orderId
  }));*/
  const updatedItems = (cartData.items || []).map(item => {
  if (item.status === "Ordered") {
    return {
      ...item,
      status: "Confirmed",
      orderId: orderId
    };
  }
  return item; // keep Ready / Served untouched
});

  return updateDoc(cartRef, {
    orderId,
    orderNo, 
    cartStatus: "Confirmed",
    items: updatedItems,
    updatedAt: serverTimestamp()
  });
});

await Promise.all(updateCartPromises);

  /*setGuestTabs(prev => {
  const updated = [...prev];
  updated[mainTab].orderPreference = orderNo;
  return updated;

  
});*/
if (!isServerBlocked) {
  setGuestTabs(prev => {
    const updated = [...prev];
    updated[mainTab].orderPreference = orderNo;
    return updated;
  });
}
console.log("Billing Preference Value:", billingPreference);
const newStatus = billingPreference === 0 || billingPreference === 1 ? "Served" : "Confirmed";
const updatedItems = currentItems.map(item =>
  item.status === "Ordered"
    ? { ...item, status: newStatus, orderId }
    : item
);

  //setAddedItems(updatedItems);
   setGuestItems(prev => ({
        ...prev,
        [mainTab]: updatedItems
      }));

 /* sessionStorage.setItem(
    getStorageKey(),
    JSON.stringify(updatedItems)
  );*/
   sessionStorage.setItem(
        `${getStorageKey()}_${mainTab}`,
        JSON.stringify(updatedItems)
      );

  //setTabValue(1);
}
 } catch (err) {

      console.error("Confirm failed:", err);

    } finally {

      confirmLockRef.current = false;
    setIsSavingOrder(false);

    }

          }}
        >
        {isSavingOrder ? (
  <>
    <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />
    Saving...
  </>
) : (
  "Confirm"
)}
        </Button>

       {(isManagerRoute || billingPreference === 1 || billingPreference === 2 || billingPreference === 3)
       /*{(
  isManagerRoute ||
  (!isManagerRoute &&
    billingPreference !== 0 &&
    billingPreference !== 1)
)*/ &&
 tableItems.length > 0 &&
  tableItems.every(item =>
    ["Served", "Cancelled"].includes(item.status || item.item?.status)
  )  && (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap", // responsive
      gap: 1.5,         
      mt: 2,
      alignItems: "center"
    }}
  >
    <Button
      variant="contained"
      color="primary"
      onClick={handlePrintBill}
    >
      Print Bill
    </Button>

    {/*<Button
      variant="contained"
      color="success"
      //onClick={() => updateOrderStatus("Paid")}
      onClick={() => setPaymentDialogOpen(true)}
    >
      Payment
    </Button>

    <Button
      variant="contained"
      color="warning"
      onClick={() => updateOrderStatus("Cancelled")}
    >
      Cancel
    </Button>*/}
    {(
        isManagerRoute ||
        billingPreference === 2 ||
        billingPreference === 3
      ) && (
        <>
          <Button
            variant="contained"
            color="success"
            onClick={() => setPaymentDialogOpen(true)}
          >
            Payment
          </Button>

          <Button
            variant="contained"
            color="warning"
            onClick={() => updateOrderStatus("Cancelled")}
          >
            Cancel
          </Button>
        </>
      )}

    {/*<Button
      variant="contained"
      color="error"
      onClick={() => updateOrderStatus("Deleted")}
    >
      Delete
    </Button>*/}
  </Box>
)}


</Box>
        </>
)}
          <Button
            variant="contained"
            sx={{
              mt: 3,
              bgcolor: darkMode ? '#4b5563' : '#735DA5',
              '&:hover': { bgcolor: darkMode ? '#6b7280' : '#a583f2' },
            }}
            onClick={handleBack}
          >
            Back to Home
          </Button>
        </>
      )}
    </Container>

    <Dialog open={paidSuccessOpen} onClose={handlePaidSuccessClose}>
  <DialogTitle>You have Successfully Paid</DialogTitle>

  <DialogActions>
    <Button onClick={handlePaidSuccessClose} variant="contained">
      OK
    </Button>
  </DialogActions>
</Dialog>

    <Dialog open={cancelSuccessOpen} onClose={handleCancelledSuccessClose}>
  <DialogTitle>You have Successfully Cancelled the order</DialogTitle>

  <DialogActions>
    <Button onClick={handleCancelledSuccessClose} variant="contained">
      OK
    </Button>
  </DialogActions>
</Dialog>

<Dialog open={deleteSuccessOpen} onClose={handleDeletedSuccessClose}>
  <DialogTitle>You have Successfully Deleted the order</DialogTitle>

  <DialogActions>
    <Button onClick={handleDeletedSuccessClose} variant="contained">
      OK
    </Button>
  </DialogActions>
</Dialog>

<Dialog open={paymentDialogOpen} onClose={() => setPaymentDialogOpen(false)}>
  <DialogTitle>Select Payment Method</DialogTitle>

  <Box sx={{ p: 2 }}>
    <FormControl fullWidth margin="dense">
      <InputLabel id="payment-label">Payment</InputLabel>

      <Select
        labelId="payment-label"  
        value={selectedPayment}
        label="Payment"          
        onChange={(e) => setSelectedPayment(e.target.value)}
      >
        {paymentOptions.map((method, index) => (
          <MenuItem key={index} value={method}>
            {method}
          </MenuItem>
        ))}
      </Select>
      {selectedPayment?.toLowerCase() === "upi" && transactionDetails !== 1 && (
  <TextField
    fullWidth
    margin="dense"
    label="Transaction ID (Optional)"
    value={transactionId}
    onChange={(e) => setTransactionId(e.target.value)}
  />
)}
    </FormControl>
  </Box>

  <DialogActions>
    <Button onClick={() => setPaymentDialogOpen(false)}>Cancel</Button>

    <Button
  variant="contained"
   disabled={isProcessingPayment}
  onClick={async () => {
      if (
      paymentLockRef.current ||
      isProcessingPayment
    ) {
      return;
    }


    
    paymentLockRef.current = true;
    setIsProcessingPayment(true);
try {
    if (!selectedPayment) return;

    //await updateOrderStatus("Paid", selectedPayment);
await updateOrderStatus("Paid", selectedPayment, transactionId);
   
    /*setTimeout(() => {
  handlePrintBill(selectedPayment);
}, 500);*/
    handlePrintBill(selectedPayment);

    setPaymentDialogOpen(false);
    setSelectedPayment("");
    setTransactionId(""); // reset after use
    } catch (err) {

      console.error(err);

    } finally {
paymentLockRef.current = false;
      setIsProcessingPayment(false);

    }
  }}
>
 {isProcessingPayment ? (
    <>
      <CircularProgress
        size={16}
        color="inherit"
        sx={{ mr: 1 }}
      />
      Processing...
    </>
  ) : (
    "Confirm Payment"
  )}
</Button>
  </DialogActions>
</Dialog>
</>
  );
};

export default Order;